<template>
  <div v-if="this.is_loaded" class="fabs" :style="[
    this.position_widget == 1
      ? {
        bottom: this.space_bottom_pc + 'px',
        right: this.space_right_pc + 'px',
      }
      : {
        bottom: this.space_bottom_pc + 'px',
        left: this.space_right_pc + 'px',
      },
  ]" :class="[
      { 'text-widget': this.widget_style == '1' },
      { 'left-position': this.position_widget == '2' },
      { 'full-screen': this.screen == 'full' },
    ]">
    <div id="fchatbody" :style="[
      this.position_widget == 1
        ? {
          bottom: parseInt(this.space_bottom_pc) - 11 + 'px',
          right: parseInt(this.space_right_pc) + 69 + 'px',
        }
        : {
          bottom: parseInt(this.space_bottom_pc) - 11 + 'px',
          left: parseInt(this.space_right_pc) + 69 + 'px',
        },
    ]" class="chat" :class="[
        { 'is-visible': this.showchat == true },
        { 'is-visible': this.screen == 'full' },
      ]">
      <a v-if="this.widget_style == 1" id="closeprime" @click="closeChat()">
        <i class="zmdi zmdi-close-circle-o"></i>
      </a>
      <!-- Header -->
      <div class="chat_header" v-bind:style="{ background: maincolor, color: font_color }">
        <div v-if="this.allowdrag == 1" id="header_drag" draggable="true" @mouseleave="activedrag = false"
          @mouseup="dragendChat($event)" @dragstart="dragstartChat($event)" @mousemove="dragChat($event)"></div>
        <div id="webchat_popup_close">
          <a href="javascript:void(0);" @click="closeChat()"><img class="close-icon"
              src="https://cdn.fchat.vn/assets/images/x-fchat.png" /></a>
        </div>
        <a v-if="this.convsation_id" id="back_conversation" @click="backConv()"><i
            class="zmdi zmdi-chevron-left"></i></a>
        <div v-if="this.salelists.length == 0" class="chat_option" :class="[{ 'has-back': this.convsation_id }]">
          <div class="header_img">
            <img width="47" height="47" :src="this.web_logo" />
          </div>
          <div class="header-text">
            <span id="chat_head">{{ this.web_name }}</span> <br />
            <span class="agent">{{ this.widget_text }}</span>
          </div>
        </div>
        <div v-else class="chat_option" :class="[{ 'has-back': this.convsation_id }]">
          <span v-for="(sale, index_sale) in this.salelists" :key="index_sale">
            <div class="header_img">
              <img width="47" height="47" :src="sale.avatar" style="background: transparent" />
            </div>
            <span id="chat_head">{{ sale.full_name }}</span> <br />
            <span class="agent"></span>
            <span class="online"><i class="zmdi zmdi-circle"></i><span class="salestatus">Online</span></span>
          </span>
        </div>
      </div>
      <!-- Conversation -->
      <div v-if="this.convsation_id" id="chat_converse" @click="
        show_icon = false;
      show_menu = false;
      " class="chat_conversion chat_converse" @scroll="ScrollMessage">
        <div id="scroll_mess">
          <div v-for="(message, index_mess) in this.messages" :key="index_mess" class="chat_mess_item">
            <div v-if="message.is_Page_Reply">
              <span class="chat_msg_item chat_msg_item_admin"
                :class="[{ 'video-item': message.template_type == 'video' }]">
                <div class="chat_avatar" v-if="message.chat_by">
                  <img v-if="message.chat_by.facebook_id" :title="message.chat_by.full_name" :src="'https://graph.facebook.com/' +
                    message.chat_by.facebook_id +
                    '/picture?type=small'
                    " />
                  <img v-else :title="message.chat_by.full_name" :src="this.web_logo" />
                </div>
                <div v-if="message.albums">
                  <div class="img-show" v-for="album_image_url in message.albums" v-bind:key="album_image_url">
                    <a :href="album_image_url" target="_blank" :style="'background-image: url(\'' + album_image_url + '\')'
                      " data-fancybox="gallery"></a>
                  </div>
                </div>
                <!-- File -->
                <div v-if="message.attachments.length > 0">
                  <div v-for="(file, b_index) in message.attachments" :key="b_index">
                    <a class="fchat-file" title="Bấm để tải xuống" target="_blank" :href="file.url"><span
                        class="fchat-file">{{ file.name }}</span>
                      <span class="fchat-download">{{ file.size }}KB<i class="zmdi zmdi-download"></i></span></a>
                  </div>
                </div>
                <span v-else v-html="nToBr(message.message)"></span>
                <!-- BUTTON -->
                <div v-if="message.buttons && !message.is_close">
                  <span v-for="(button_item, b_index) in message.buttons" :key="b_index">
                    <a v-if="button_item.type == 'postback'" class="_btn _btn_buttons" :title="button_item.title"
                      @click="sendBlock(button_item)">{{ button_item.title }}</a>
                    <a v-else-if="button_item.type == 'phone_number'" class="_btn _btn_buttons"
                      :href="'tel:' + button_item.payload" :title="button_item.title">{{ button_item.title }}</a>
                    <a v-else-if="
                      button_item.type == 'web_url' ||
                      button_item.type == 'buy' ||
                      button_item.type == 'cart'
                    " class="_btn _btn_buttons" @click="openLink(button_item, message._id)"
                      :title="button_item.title">{{ button_item.title }}</a>
                    <a v-else class="_btn _btn_buttons">{{
                      button_item.title
                      }}</a>
                  </span>
                </div>
                <!-- END BUTTON -->
                <div v-if="message.template_type == 'video'">
                  <div v-if="
                    this.checkVideoSource(message.attachments[0].payload.url)
                  " class="video-container facebook-video">
                    <span style="opacity: 0">{{
                      message.attachments[0].payload.url
                      }}</span>
                    <iframe :src="'https://www.facebook.com/plugins/video.php?href=' +
                      message.attachments[0].payload.url +
                      '&show_text=false&width=245&height=140'
                      " width="245" height="140" style="border: none; overflow: hidden" allowTransparency="true"
                      scrolling="no" frameborder="0" allowfullscreen="true"></iframe>
                  </div>
                  <div v-else class="video-container">
                    <span style="opacity: 0">{{
                      message.attachments[0].payload.url
                      }}</span>
                    <iframe width="245" height="140" :src="'https://www.youtube.com/embed/' +
                      this.getIdYoutube(message.attachments[0].payload.url)
                      " frameborder="0" allowfullscreen></iframe>
                  </div>
                </div>
                <!-- GALLERY -->
                <div v-if="message.elements" :class="'slideshow-container slideshow' + index_mess">
                  <div :class="'mySlides mySlides' + index_mess + index + ' fade'"
                    v-for="(element, index) in message.elements" :key="index">
                    <a v-if="element.item_url" :href="element.item_url" target="_blank">
                      <img :src="element.image_url" style="width: 100%" />
                      <div class="slide-content">
                        <div class="title">{{ element.title }}</div>
                        <div class="des">{{ element.subtitle }}</div>
                        <span v-for="(button_item, b_index) in element.buttons" :key="b_index">
                          <a v-if="button_item.type == 'postback'" href="#" class="_btn _btn_buttons"
                            :title="button_item.payload" @click="sendBlock(button_item)">{{ button_item.title }}</a>
                          <a v-else-if="button_item.type == 'phone_number'" class="_btn _btn_buttons"
                            :href="'tel:' + button_item.payload" :title="button_item.payload">{{ button_item.title
                            }}</a>
                          <a v-else-if="button_item.type == 'web_url'" target="_blank" class="_btn _btn_buttons"
                            :href="button_item.url" :title="button_item.payload">{{ button_item.title }}</a>
                          <a v-else class="_btn _btn_buttons">{{
                            button_item.title
                            }}</a>
                        </span>
                      </div>
                    </a>
                    <a v-else href="#">
                      <img :src="element.image_url" style="width: 100%" />
                      <div class="slide-content">
                        <div class="title">{{ element.title }}</div>
                        <div class="des">{{ element.subtitle }}</div>
                        <span v-for="(button_item, b_index) in element.buttons" :key="b_index">
                          <a v-if="button_item.type == 'postback'" href="#" class="_btn _btn_buttons"
                            :title="button_item.payload" @click="sendBlock(button_item)">{{ button_item.title }}</a>
                          <a v-else-if="button_item.type == 'phone_number'" class="_btn _btn_buttons"
                            :href="'tel:' + button_item.payload" :title="button_item.payload">{{ button_item.title
                            }}</a>
                          <a v-else-if="button_item.type == 'web_url'" target="_blank" class="_btn _btn_buttons"
                            :href="button_item.url" :title="button_item.payload">{{ button_item.title }}</a>
                          <a v-else-if="
                            button_item.type == 'web_url' ||
                            button_item.type == 'buy' ||
                            button_item.type == 'cart'
                          " class="_btn _btn_buttons" @click="openLink(button_item, message._id)"
                            :title="button_item.title">{{ button_item.title }}</a>
                          <a v-else class="_btn _btn_buttons">{{
                            button_item.title
                            }}</a>
                        </span>
                      </div>
                    </a>
                    <a class="prev" v-if="message.elements.length > 1" @click="
                      plusSlides(
                        message.elements.length,
                        index_mess,
                        index,
                        false
                      )
                      ">&#10094;</a>
                    <a class="next" v-if="message.elements.length > 1" @click="
                      plusSlides(
                        message.elements.length,
                        index_mess,
                        index,
                        true
                      )
                      ">&#10095;</a>
                  </div>
                </div>
                <span class="status2">{{
                  this.showDateDetail(message.created_at)
                  }}</span>
              </span>
            </div>
            <div v-else>
              <span class="chat_msg_item chat_msg_item_user user_chat" v-if="
                message.message ||
                message.albums ||
                message.attachments ||
                message.buttons
              " :class="[
                  {
                    'image-item': message.albums && message.albums.length != 0,
                  },
                ]">
                <span v-if="message.albums">
                  <div class="img-show" v-for="album_image_url in message.albums" v-bind:key="album_image_url">
                    <a :href="album_image_url" target="_blank" :style="'background-image: url(\'' + album_image_url + '\')'
                      " data-fancybox="gallery"></a>
                  </div>
                </span>
                <!-- File -->
                <div v-if="message.attachments && message.attachments.length != 0">
                  <div v-for="(file, b_index) in message.attachments" :key="b_index">
                    <a class="fchat-file" title="Bấm để tải xuống" target="_blank" :href="file.url"><span
                        class="fchat-file">{{ file.name }}</span>
                      <span class="fchat-download">{{ file.size }}KB<i class="zmdi zmdi-download"></i></span></a>
                  </div>
                </div>
                <span v-else v-html="nToBr(message.message)"></span>
                <!-- BUTTON -->
                <div v-if="message.buttons">
                  <p v-for="(button_item, b_index) in message.buttons" :key="b_index">
                    <a v-if="button_item.type == 'postback'" class="_btn _btn_buttons">{{ button_item.title }}</a>
                  </p>
                </div>

                <!-- END BUTTON -->
                <span class="status">{{
                  this.showDateDetail(message.created_at)
                  }}</span>
                <div class="status_send">
                  <i title="Chờ gửi" v-if="message.status == 0" class="zmdi zmdi-circle-o" aria-hidden="true"></i>
                  <i title="Đã gửi" v-else-if="message.status == 1" class="zmdi zmdi-check-circle"
                    aria-hidden="true"></i>
                  <i title="Gửi thất bại" v-else-if="message.status == 2" class="zmdi zmdi-info" aria-hidden="true"></i>
                  <i title="Đang gửi" v-else-if="message.status == 3" class="zmdi zmdi-spinner zmdi-hc-spin"
                    aria-hidden="true"></i>
                </div>
              </span>
            </div>
          </div>
          <div class="clearfix"></div>
          <div v-if="this.data_quickshow.length > 0" class="quick-reply">
            <a v-for="(q_item, q_index) in data_quickshow" :key="q_index" :title="q_item.payload"
              @click="sendQuick(q_item)">{{ q_item.title }}</a>
          </div>
          <div v-if="this.data_assistantshow.length > 0" class="quick-reply">
            <a v-for="(q_item, q_index) in data_assistantshow" :key="q_index" :title="q_item.payload"
              @click="sendQuickAssistant(q_item)">{{ q_item.title }}</a>
          </div>
          <div v-if="this.show_rating">
            <div id="conversation-rating">
              <div v-if="this.has_rate">
                <div class="has-rating">
                  <img :src="'https://cdn.fchat.vn/assets/images/rating/' +
                    this.rate_value +
                    '.png'
                    " />
                </div>
                <div class="title-rating">{{ this.text_reviewthank }}</div>
                <div class="desc-rating">{{ this.text_reviewthankdes }}</div>
              </div>
              <div v-else>
                <div class="title-rating">{{ this.text_reviewconv }}</div>
                <div class="desc-rating">{{ this.text_reviewdes }}</div>
                <div id="item-rating">
                  <img :src="'https://cdn.fchat.vn/assets/images/rating/' +
                    rate.value +
                    '.png'
                    " :title="rate.title" @click="sendRating(rate.value)" v-for="(rate, index_rate) in this.rates"
                    :key="index_rate" />
                </div>
              </div>
            </div>
          </div>

          <div id="typing_chat2">
            <div v-if="firstPageReplyMessage()" class="chat_mess_item">
              <span class="chat_msg_item chat_msg_item_admin" :class="[
                {
                  'video-item':
                    firstPageReplyMessage().template_type == 'video',
                },
              ]">
                <div v-if="
                  firstPageReplyMessage().chat_by &&
                  firstPageReplyMessage().chat_by.facebook_id
                " class="chat_avatar">
                  <img :title="firstPageReplyMessage().chat_by.facebook_id" :src="'https://graph.facebook.com/' +
                    firstPageReplyMessage().chat_by.facebook_id +
                    '/picture?type=small'
                    " />
                </div>
                <div v-else class="chat_avatar">
                  <img :title="firstPageReplyMessage.chat_by.facebook_id" :src="'https://graph.facebook.com/' +
                    firstPageReplyMessage().chat_by.facebook_id +
                    '/picture?type=small'
                    " />
                </div>
                <div>
                  <img src="https://cdn.fchat.vn/assets/images/ic_typing_round1.svg" />
                </div>
              </span>
            </div>
          </div>
          <div id="typing_chat4">
            <img src="https://fchat.vn/assets/images/logo/favicon-c.png"
              style="width: 38px; height: 38px; margin-left: 12px" />
            <img src="https://cdn.fchat.vn/assets/images/ic_typing_round1.svg" />
          </div>

          <div id="typing_chat1">
            <div v-if="lastPageReplyMessage()" class="chat_mess_item">
              <span class="chat_msg_item chat_msg_item_admin" :class="[
                {
                  'video-item':
                    lastPageReplyMessage().template_type == 'video',
                },
              ]">
                <div v-if="
                  lastPageReplyMessage().chat_by &&
                  lastPageReplyMessage().chat_by.facebook_id
                " class="chat_avatar">
                  <img :title="lastPageReplyMessage().chat_by.full_name" :src="web_logo" />
                </div>
                <div v-else class="chat_avatar">
                  <img :title="lastPageReplyMessage().chat_by.full_name" :src="web_logo" />
                </div>
                <div>
                  <img src="https://cdn.fchat.vn/assets/images/ic_typing_round1.svg" />
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- Start Screen -->
      <div v-else>
        <div id="chat_converse" class="chat_converse chat_form">
          <div v-if="this.is_login">
            <div class="list-conversation">
              <div class="conversation_list_inner">
                <p class="block-title" v-if="this.conversations.length > 0">
                  {{ this.text_convlist
                  }}<span v-if="this.conversations.length > 3" class="view-all-conv" @click="viewAllConv()">{{
                    this.text_convall }}
                    <i class="zmdi" :class="[
                      {
                        'zmdi-chevron-down':
                          this.text_convall == 'Xem tất cả',
                      },
                      { 'zmdi-chevron-up': this.text_convall == 'Thu gọn' },
                    ]"></i></span>
                </p>
                <p v-else>{{ this.welcome_txt }}</p>
                <div class="conv-item-list">
                  <div v-for="(conv, index_conv) in this.conversations.slice(
                    0,
                    this.show_convnum
                  )" :key="index_conv" @click="viewConv(conv)">
                    <div class="conv-item" v-if="conv && conv.last_mess">
                      <div class="conv_avatar">
                        <img v-if="conv.sale_avatar" :src="conv.sale_avatar" /><img v-else :src="this.web_logo" />
                        <span v-if="!conv.isReadWeb" class="icon-new-message">1</span>
                      </div>
                      <div class="conv_details">
                        <div class="first-line">
                          <div class="staff-name">
                            <span v-if="conv.sale_name">{{
                              conv.sale_name
                              }}</span><span v-else>{{ this.web_name }}</span>
                          </div>
                          <div class="time">
                            {{ this.showDateDetail(conv.updated_at) }}
                          </div>
                        </div>
                        <div class="content-conv" v-if="conv.last_mess">
                          <p class="content">
                            <span v-if="conv.last_mess.message">{{
                              conv.last_mess.message
                              }}</span><span v-else>Tệp đính kèm</span>
                          </p>
                          <p class="conv-status close" v-if="conv.is_done">
                            {{ this.text_convclose }}
                          </p>
                          <p class="conv-status wating" v-else-if="!conv.isReadWeb">
                            {{ this.text_convwating }}
                          </p>
                          <p class="conv-status open" v-else>
                            {{ this.text_convopen }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="create-new-conv">
                  <button v-bind:style="{ background: maincolor, color: font_color }" @click="startChat()">
                    {{ this.text_newchat
                    }}<i class="zmdi zmdi-chevron-right"></i>
                  </button>
                  <div class="sales-online">
                    <span class="sales-item" v-for="(sale, index_sale) in this.salesonline" :key="index_sale">
                      <img :src="sale.avatar" :title="sale.full_name" v-if="sale.avatar" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="chat_body chat_login">
              <p>{{ this.welcome_txt }}</p>
              <div class="sales-online">
                <span class="sales-item" v-for="(sale, index_sale) in this.salesonline" :key="index_sale">
                  <img :src="sale.avatar" :title="sale.full_name" v-if="sale.avatar" />
                </span>
              </div>
            </div>
            <div class="fchat-form-validate" v-if="errors.length">
              <ul>
                <li v-for="(error, index_error) in this.errors" :key="index_error">
                  {{ error }}
                </li>
              </ul>
            </div>
            <div class="message_form">
              <input v-if="this.form_field['name']['enable'] == 1" v-model="form_name" name="name"
                :placeholder="this.text_formname" @keydown="inputName" ref="name_input" />
              <input v-if="this.form_field['email']['enable'] == 1" v-model="form_email" name="email"
                :placeholder="this.text_formemail" />
              <input v-if="this.form_field['phone']['enable'] == 1" v-model="form_phone" name="phone"
                :placeholder="this.text_formphone" />
              <button v-bind:style="{ background: maincolor, color: font_color }" @click="createConversation()">
                {{ this.button_start }}
              </button>
            </div>
          </div>
          <div class="channel_block" v-if="
            this.contact_social &&
            (this.contact_social.whatsapp ||
              this.contact_social.zalo ||
              this.contact_social.phone ||
              this.contact_social.message ||
              this.contact_social.email)
          ">
            <div class="channel_block_inner">
              <p class="block-title">{{ this.title_contact_social }}</p>
              <div class="channel-items">
                <div class="channel-item" v-for="(item, index_item) in this.contact_social" :key="index_item">
                  <a v-if="item.name == 'phone'" :href="'tel:' + item.url"><img :src="'https://cdn.fchat.vn/assets/images/social/' +
                    item.name +
                    '.png'
                    " />{{ item.title }}</a>
                  <a v-else-if="item.name == 'email'" :href="'mailto:' + item.url"><img :src="'https://cdn.fchat.vn/assets/images/social/' +
                    item.name +
                    '.png'
                    " />{{ item.title }}</a>
                  <a v-else-if="item.name == 'zalo'" target="_blank" :href="'https://zalo.me/' + item.url"><img :src="'https://cdn.fchat.vn/assets/images/social/' +
                    item.name +
                    '.png'
                    " />{{ item.title }}</a>
                  <a v-else-if="item.name == 'whatsapp'" target="_blank" :href="'https://wa.me/' + item.url"><img :src="'https://fchat.co/assets/images/social/' +
                    item.name +
                    '.png'
                    " />{{ item.title }}</a>
                  <a v-else target="_blank" :href="item.url"><img :src="'https://cdn.fchat.vn/assets/images/social/' +
                    item.name +
                    '.png'
                    " />{{ item.title }}</a>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Chat form -->
      <div v-if="this.convsation_id" class="fab_field">
        <div v-if="this.show_rating">
          <div class="continue-text">
            <div class="conv-done">{{ this.text_convhasclose }}</div>
            <span>Bạn có thể
              <a v-bind:style="{ color: maincolor }" class="repenchat" href="#"><b @click="reOpenChat()">tiếp tục
                  chat</b></a>
              hoặc </span><button v-bind:style="{ background: maincolor, color: font_color }" @click="startChat()">
              Mở phiên chat mới
            </button>
          </div>
        </div>
        <div v-else>
          <div id="image_preview_box" v-if="this.img_preview">
            <img :title="this.file_preview" :src="this.img_preview" /><i @click="removePreviewimg"
              class="zmdi zmdi-close"></i>
          </div>
          <a id="fab_camera" class="fab is-visible" @click="show_menu = false">
            <label style="margin-right: 6px">
              <input type="file" name="imgchat" @change="uploadImage($event)" id="img_input" />
              <i class="zmdi zmdi-attachment-alt"></i>
            </label>
            <label>
              <i class="zmdi zmdi-mood" @click="show_icon = !show_icon"></i>
              <div v-if="this.show_icon">
                <Emoji @closeiconUpdated="this.show_icon = $event" @iconUpdated="this.send_text = $event"
                  :send_text="this.send_text" />
              </div>
            </label>
          </a>
          <div v-if="this.menus.length > 0" class="fchat-menu-show" v-show="show_menu">
            <div v-for="(item, i) in this.menus" :key="i">
              <div v-if="item.title" class="menu-item">
                <a @click="clickMenu(item)">{{ item.title }}</a>
              </div>
            </div>
            <span class="arrow"></span>
          </div>
          <a id="fab_send" title="Menu" v-if="!this.img_preview && !this.send_text && this.menus.length > 0" @click="
            show_menu = !show_menu;
          show_icon = false;
          " class="fab is-visible"><i class="zmdi zmdi-menu" style="color:#42a4f5"></i></a>
          <a id="fab_send" v-else @click="beforeSendChat()" style="color:#42a4f5" class="fab is-visible"><i
              class="zmdi zmdi-mail-send" style="color:#42a4f5"></i></a>
          <div id="chatsend_height">
            <textarea @paste="onChangeImage($event)" @keyup="autoHeight()" @click="
              show_icon = false;
            show_menu = false;
            " id="chatSend" v-model="send_text" name="chat_message" :placeholder="this.text_formmess"
              class="chat_field chat_message" @keydown="inputHandler" ref="main_textarea"></textarea>
          </div>
        </div>
      </div>
      <!-- Power by -->
      <div v-if="this.hide_PoweredBy == 0" id="power_by" @click="show_menu = false">
        <span>Powered by
          <a :href="base_url + '?src=webchat'" target="_blank">fchat.vn</a></span>
      </div>
    </div>

    <div v-if="!checkHidden && (!chatbutton || (chatbutton && chatbutton != 'true'))" class="preview-message">
      <a v-if="this.preview_conv && this.preview_conv.length > 0" @click="removeMess" class="close"><img
          class="close-icon" src="https://cdn.fchat.vn/assets/images/x-fchat.png" /></a>
      <div class="message-item" v-for="(conv, index_conv) in this.preview_conv" :key="index_conv">
        <span v-html="nToBr(conv.message)"></span>
      </div>
      <div v-if="this.list_quick_welcome && this.list_quick_welcome.length > 0" class="quick-reply">
        <a v-bind:style="{ border: '1px solid ' + maincolor + '' }" v-for="(q_item, q_index) in list_quick_welcome"
          :key="q_index" @click="sendBlockPreview(q_item)">{{ q_item.title }}</a>
      </div>
    </div>
    <div class="overlay" :class="[{ visible: this.showchat == true }]" @click="closeChat()"></div>
    <!-- Start button -->
    <a v-if="this.widget_style == 2 && !this.checkHidden && (!chatbutton || (chatbutton && chatbutton != 'true'))"
      v-bind:style="{ background: maincolor, color: font_color }" id="prime" @click="openChat()" class="fab"
      :class="[{ 'is-float is-visible': this.showchat == true }]">
      <img :class="[
        { 'is-active close-icon': this.showchat == true },
        { '': this.showchat == false },
      ]"
        :style="{ width: (pageData && pageData.settings && pageData.settings.icon_width) ? (pageData.settings.icon_width + 'px') : '30px', height: pageData?.settings?.icon_height ? (pageData.settings.icon_height + 'px') : '30px', marginTop: this.icon ? '8px' : '14px' }"
        :src="this.showchat == true
            ? ('https://cdn.fchat.vn/assets/images/x-fchat.png')
            : (this.icon || 'https://cdn.fchat.vn/assets/images/fchat-icon.png')
          " />
      <span v-if="this.unread_count > 0" class="icon-new-message">{{
        this.unread_count
        }}</span>
    </a>
    <a v-else-if="this.widget_style != 2 && !this.checkHidden && !this.chatbutton"
      v-bind:style="{ background: maincolor, color: font_color }" id="prime_text" @click="openChat()"
      class="widget-text" :class="[{ 'is-none': this.showchat == true }]">
      <div class="chat_logo">
        <img :src="this.web_logo" />
      </div>
      {{ this.widget_text }}
    </a>
  </div>
</template>
<script>
import config from "./config";
import axios from "axios";
import moment from "moment";
moment.locale("vi");
moment.suppressDeprecationWarnings = true;
import io from "socket.io-client";
import helpers from "./helper/helper";
import Emoji from "./components/emoji.vue";
export default {
  name: "App",
  components: {
    Emoji,
  },
  props: {
    selected: Boolean,
    id: String,
    crmid: String,
    name: String,
    phone: String,
    email: String,
    screen: String,
    avatar: String,
    chatbutton: String,
  },
  data() {
    return {
      icon: '',
      quick_select: "",
      is_loaded: false,
      pageData: [],
      welcome_data: {},
      show_icon: false,
      unread_count: 0,
      chat_now: true,
      data_quick_delay: [],
      first_mess: true,
      list_quick_welcome: [],
      first_mess_time: 3,
      first_mess_retime: 24,
      salelists: [],
      menus: [],
      checkHidden: true,
      show_menu: false,
      conversations: [],
      preview_conv: [],
      block_id_greeting: "",
      show_convnum: 3,
      salesonline: [],
      page_limit: 20,
      showchat: false,
      is_login: false,
      widget_style: 2,
      phone_number: "",
      widget_text: "",
      language: "",
      img_preview: "",
      file_preview: "",
      send_file: false,
      maincolor: "#42a5f5",
      font_color: 1,
      position_widget: 1,
      welcome_txt: "",
      button_start: "",
      errors: [],
      web_name: "",
      web_logo: "",
      sale_name: "",
      send_text: "",
      form_name: "",
      form_email: "",
      form_phone: "",
      tex_resgpt: "",
      text_newconv: "",
      text_formname: "",
      text_formemail: "",
      text_formphone: "",
      text_formmess: "",
      text_convlist: "",
      text_convall: "",
      text_convclose: "",
      text_convwating: "",
      text_convopen: "",
      text_newchat: "",
      text_newmessage: "",
      text_convhasclose: "",
      text_reviewconv: "",
      text_reviewdes: "",
      text_reviewthank: "",
      text_reviewthankdes: "",
      text_newmessagegpt: "",
      convsation_id: "",
      id_assistants: "",
      id_threads: "",
      assistant_status_1: "",
      assistant_status: "",
      allConversationInfos: [],
      fchat_userid: "",
      messages: [],
      contact_social: [],
      title_contact_social: "",
      page: 1,
      view_conv: true,
      socket: io(config.SOCKET_URL, {
        transports: ["websocket"],
        pingTimeout: 60000,
        reconnection: true,
        reconnectionDelay: 500,
        maxReconnectionAttempts: Infinity,
      }),
      file_img: "",
      data_upload_img: [],
      page_cookies: [],
      allowdrag: 0,
      show_salesonline: 0,
      activedrag: false,
      currentX: null,
      data_userinputnext: [],
      token_shop_api: "",
      token_gpt_assistant: "",

      data_quicknext: [],
      data_quickshow: [],
      data_assistantshow: [],
      data_webform: [],
      currentY: null,
      initialX: null,
      initialY: null,
      xOffset: 0,
      yOffset: 0,
      hide_PoweredBy: 0,
      show_rating: false,
      has_rate: false,
      rate_value: "",
      base_url: config.BASE_URL,
      check_done: false,
      form_field: [],
      space_bottom_pc: "16",
      space_bottom_mobile: "16",
      space_right_pc: "16",
      space_right_mobile: "16",
      titleLoop: null,
      has_clicked: false,
      site_Title: document.title,
      crm_url: "",
      rates: [
        {
          value: 1,
          title: "Very Bad",
        },
        {
          value: 2,
          title: "Bad",
        },
        {
          value: 3,
          title: "Normal",
        },
        {
          value: 4,
          title: "Good",
        },
        {
          value: 5,
          title: "Wonderful",
        },
      ],
      isOnLine: navigator.onLine,
      last_send: 0,
      fchat_link_block: [],
      closed_preview: 0,
    };
  },
  methods: {
    lastPageReplyMessage() {
      const firstPageReplyMessage = this.messages.find(
        (message) =>
          message.is_Page_Reply && message.chat_by && message.chat_by.full_name
      );
      return firstPageReplyMessage || null;
    },
    firstPageReplyMessage() {
      const firstPageReplyMessage = this.messages.find(
        (message) =>
          message.is_Page_Reply &&
          message.chat_by &&
          message.chat_by.facebook_id
      );
      return firstPageReplyMessage || null;
    },

    openLink(button, id) {
      var url = button.url;

      if (button.webview_height_ratio == "full") {
        var w = 550;
        var h = 550;
        var data_block = {};
        if (this.data_webform) {
          this.data_webform.forEach((webform) => {
            if (webform.id == id) {
              data_block = webform;
            }
          });
        }
        var left = screen.width / 2 - w / 2;
        var top = screen.height / 2 - h / 2;
        if (data_block.data) {
          window.open(
            url,
            "window_open",
            "location=no,toolbar=no,directories=no,menubar=no,resizable=no,copyhistory=no,scrollbars=no,status=no,width=" +
            w +
            ", height=" +
            h +
            ", top=" +
            top +
            ", left=" +
            left
          );
        } else {
          window.open(
            url +
            this.getConcatUrl(url) +
            "user_id=" +
            this.fchat_userid +
            "&page_id=" +
            this.id +
            "&type=1",
            "window_open",
            "location=no,toolbar=no,directories=no,menubar=no,resizable=no,copyhistory=no,scrollbars=no,status=no,width=" +
            w +
            ", height=" +
            h +
            ", top=" +
            top +
            ", left=" +
            left
          );
        }
      } else {
        window.open(url, "_blank");
      }
    },
    clickMenu(item) {
      this.show_menu = false;
      if (item.type == "web_url") {
        window.open(item.value, "_blank");
      } else {
        var button = { title: item.title, payload: item.value };
        this.sendBlock(button);
      }
    },
    getConcatUrl(url) {
      let concat = "?";
      if (url.indexOf("?") > -1) {
        concat = "&";
      }
      return concat;
    },
    getIdYoutube(url) {
      const regExp =
        /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);
      return match && match[2].length === 11 ? match[2] : null;
    },
    checkVideoSource(url) {
      let check = url.includes("facebook");
      return check;
    },
    async createConversation(sendMess = false, button = false) {
      this.errors = [];
      if (
        this.form_field["name"]["enable"] == 1 &&
        this.form_field["name"]["required"] == 1 &&
        !this.form_name
      ) {
        if (this.language == "english") {
          this.errors.push("Name field is required.");
        } else {
          this.errors.push("Vui lòng nhập tên của bạn.");
        }
      }
      if (
        this.form_field["phone"]["enable"] == 1 &&
        this.form_field["phone"]["required"] == 1 &&
        !this.form_phone
      ) {
        if (this.language == "english") {
          this.errors.push("Phone field is required.");
        } else {
          this.errors.push("Vui lòng nhập số điện thoại.");
        }
      }
      if (
        this.form_field["email"]["enable"] == 1 &&
        this.form_field["email"]["required"] == 1 &&
        !this.form_email
      ) {
        if (this.language == "english") {
          this.errors.push("Email field is required.");
        } else {
          this.errors.push("Vui lòng nhập email của bạn.");
        }
      } else if (
        this.form_field["email"]["enable"] == 1 &&
        this.form_email &&
        !this.validEmail(this.form_email)
      ) {
        if (this.language == "english") {
          this.errors.push("Invalid email.");
        } else {
          this.errors.push("Email không hợp lệ.");
        }
      }
      if (!this.errors.length) {
        var ref = this.getCookie("ref");
        var src = this.getCookie("src");
        if (!ref) {
          ref = window.location.hostname;
        }

        let url_current = window.location.href;
        let cookies_value = "";
        for (let i in this.page_cookies) {
          let field = this.page_cookies[i].field;
          if (!field) {
            continue;
          }
          let value = this.getCookie(field);
          if (!value) {
            continue;
          }
          let cookie_param = "&" + field + "=" + value;
          cookies_value += cookie_param;
        }

        if (cookies_value) {
          url_current += cookies_value;
        }
        let data_json = {
              page_id: this.id,
              sender_name: this.form_name ? this.form_name : "Guest",
              email: this.form_email ? this.form_email : "",
              phone: this.form_phone ? this.form_phone : "",
              lastmess: this.text_newconv,
              ref: ref,
              src: src,
              crmid: this.crm_url,
              url: url_current,
              title: document.title,
            }
            if(this.avatar) {
              data_json.avatar = this.avatar;
            }

        await axios
          .post(
            config.API_URL_CLIENT + "webchat/createConv",
            data_json,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            localStorage.setItem("fchat_login", true);
            localStorage.setItem("fchat_userid", response.data.sender_id);
            localStorage.setItem("convsation_id", response.data.conv_id);
            localStorage.setItem("fchat_page_id", this.id);
            sessionStorage.setItem(
              "fchat_last_url",
              this.RemoveParamUrl(window.location.href)
            );
            this.is_login = true;
            this.fchat_userid = response.data.sender_id;
            this.convsation_id = response.data.conv_id;
            this.socket.emit("room", this.id);
            this.loadMessages(this.convsation_id, 0);
            if (response.data.datas.sale_name) {
              this.salelists = [];
              this.salelists.push({
                avatar: response.data.datas.sale_avatar,
                full_name: response.data.datas.sale_name,
              });
              localStorage.setItem("fchat_sale", response.data.datas.sale_name);
              localStorage.setItem(
                "fchat_sale_avatar",
                response.data.datas.sale_avatar
              );
            }
            if (sendMess) {
              this.sendChat();
            }
            localStorage.setItem("newconv_assistant", "1");
            this.sendGreating();

            if (button) {
              var _this = this;
              setTimeout(function () {
                _this.sendBlock(button);
              }, 1000);
            }
            if (this.data_quick_delay && this.data_quick_delay.length > 0) {
              var _this = this;
              setTimeout(function () {
                _this.sendBlock(_this.data_quick_delay);
              }, 1000);
            }
            var _this = this;
            this.pingToServer();
            setInterval(function () {
              _this.pingToServer();
              sessionStorage.setItem("fchat_last_url", "");
            }, 60000 * 5);
          })
          .catch((e) => {
            console.log(e);
          });
        var container_typing = this.$el.querySelector("#typing_chat4");
        // container_typing.style.display = 'block';
        container_typing.style.display = "none";
        var allIdConvertions =
          JSON.parse(localStorage.getItem("convsation_idList")) || [];
        // Thêm giá trị mới vào mảng
        allIdConvertions.push(this.convsation_id);
        // Lưu mảng mới vào localStorage
        localStorage.setItem(
          "convsation_idList",
          JSON.stringify(allIdConvertions)
        );
        var conversationInfo = {
          convsation_id: localStorage.getItem("convsation_id"),
          assistant_id: localStorage.getItem("assistant_id"),
        };
        // Chuyển đối tượng thành chuỗi JSON và lưu vào localStorage
        localStorage.setItem(
          "conversationInfo",
          JSON.stringify(conversationInfo)
        );
        var allConversationInfos =
          JSON.parse(localStorage.getItem("conversationInfoList")) || [];

        // Thêm đối tượng mới vào mảng
        allConversationInfos.push(conversationInfo);

        // Hiển thị tất cả các giá trị trong mảng
        localStorage.setItem(
          "conversationInfoList",
          JSON.stringify(allConversationInfos)
        );
      }
    },
    reOpenChat() {
      axios
        .post(
          config.API_URL + "webchat/reopen",
          {
            conv_id: this.convsation_id,
            sender_id: this.fchat_userid,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (!response.data.error) {
            this.show_rating = false;
            localStorage.setItem("fchat_show_rating", false);
          }
        });
    },
    async startChat() {
      this.convsation_id = "1";
      this.messages = [];
      this.clearIntTitle();
      localStorage.removeItem("convsation_id");
      localStorage.removeItem("fchat_show_rating");
      localStorage.removeItem("fchat_has_rate");
      localStorage.removeItem("fchat_rate_value");
      this.show_rating = false;
      this.has_rate = false;
      this.rate_value = "";
      var ref = this.getCookie("ref");
      var src = this.getCookie("src");
      if (!ref) {
        ref = window.location.hostname;
      }
      let url_current = window.location.href;
      let cookies_value = "";
      for (let i in this.page_cookies) {
        let field = this.page_cookies[i].field;
        if (!field) {
          continue;
        }
        let value = this.getCookie(field);
        if (!value) {
          continue;
        }
        let cookie_param = "&" + field + "=" + value;
        cookies_value += cookie_param;
      }

      if (cookies_value) {
        url_current += cookies_value;
      }

      await axios
        .post(
          config.API_URL_CLIENT + "webchat/newConv",
          {
            page_id: this.id,
            lastmess: this.text_newconv,
            sender_id: this.fchat_userid,
            url: url_current,
            title: document.title,
            id_assistants: this.id_assistants,
            id_threads: this.id_threads,
            ref: ref,
            src: src,
            crmid: this.crm_url,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.convsation_id = response.data.conv_id;
          // id_conv = response.data.conv_id;;
          this.fchat_userid = response.data.datas.sender_id;
          localStorage.setItem("convsation_id", response.data.conv_id);
          // id_conv = this.convsation_id;
          //console.log(this.convsation_id, '+',id_conv,'::',localStorage.getItem('id_assistants'),'::',this.id_threads);
          // localStorage.setItem('id_assistants',localStorage.getItem('id_assistants'));
          // localStorage.setItem('id_threads',localStorage.getItem('id_threads'));
          localStorage.setItem("fchat_userid", response.data.datas.sender_id);
          localStorage.setItem("fchat_login", true);
          localStorage.setItem("fchat_page_id", this.id);
          sessionStorage.setItem(
            "fchat_last_url",
            this.RemoveParamUrl(window.location.href)
          );
          this.sendGreating();
          // console.log('co qua day');
          if (response.data.datas.sale_name) {
            this.salelists = [];
            this.salelists.push({
              avatar: response.data.datas.sale_avatar,
              full_name: response.data.datas.sale_name,
            });
            localStorage.setItem("fchat_sale", response.data.datas.sale_name);
            localStorage.setItem(
              "fchat_sale_avatar",
              response.data.datas.sale_avatar
            );
          }
          var _this = this;
          this.pingToServer();
          setInterval(function () {
            _this.pingToServer();
            sessionStorage.setItem("fchat_last_url", "");
          }, 60000 * 5);
        });
      var container_typing4 = this.$el.querySelector("#typing_chat4");
      //container_typing4.style.display = 'block';
      container_typing4.style.display = "none";
      // Lấy tất cả các giá trị từ localStorage
      //   var allIdConvertions = JSON.parse(localStorage.getItem('convsation_idList')) || [];
      //   // Thêm giá trị mới vào mảng
      //   allIdConvertions.push(this.convsation_id);
      //   // Lưu mảng mới vào localStorage
      //   localStorage.setItem('convsation_idList', JSON.stringify(allIdConvertions));
      //   // Hiển thị tất cả các giá trị
      // // Giả sử có một đối tượng chứa thông tin hội thoại
      //   var conversationInfo = {
      //     convsation_id: localStorage.getItem('convsation_id') ,
      //       assistant_id: localStorage.getItem('assistant_id'),
      //       // Các thông tin khác
      //   };
      //   // Chuyển đối tượng thành chuỗi JSON và lưu vào localStorage
      //       localStorage.setItem('conversationInfo', JSON.stringify(conversationInfo));
      //       var allConversationInfos = JSON.parse(localStorage.getItem('conversationInfoList')) || [];

      //       // Thêm đối tượng mới vào mảng
      //       allConversationInfos.push(conversationInfo);

      //       // Hiển thị tất cả các giá trị trong mảng
      //       localStorage.setItem('conversationInfoList', JSON.stringify(allConversationInfos));

      // Bạn có thể thực hiện tìm kiếm trong mảng theo điều kiện mong muốn
      //       var convsationIdToSearch = localStorage.getItem('convsation_id');
      //       var matchingInfos = allConversationInfos.filter(info => info.convsation_id === convsationIdToSearch);

      //       // Hiển thị tất cả các conversationInfo thỏa mãn điều kiện

      //console.log('da chay het');
    },
    viewConv(convid) {
      if (!convid.isReadWeb) {
        this.updateRead(convid._id);
      }
      this.clearIntTitle();
      this.messages = [];
      this.convsation_id = convid._id;
      localStorage.setItem("convsation_id", convid._id);
      if (!convid.is_done) {
        var _this = this;
        this.pingToServer();
        setInterval(function () {
          _this.pingToServer();
          sessionStorage.setItem("fchat_last_url", "");
        }, 60000 * 5);
        this.webAction(1);
      }
      if (convid.sale_avatar) {
        this.salelists.push({
          avatar: convid.sale_avatar,
          full_name: convid.sale_name,
        });
        localStorage.setItem("fchat_sale", convid.sale_name);
        localStorage.setItem("fchat_sale_avatar", convid.sale_avatar);
      } else {
        this.salelists = [];
        localStorage.removeItem("fchat_sale");
        localStorage.removeItem("fchat_sale_avatar");
      }

      if (convid.is_done) {
        this.loadMessages(convid._id, 0, true);
        this.show_rating = true;
        localStorage.setItem("fchat_show_rating", true);
        if (convid.rating) {
          this.has_rate = true;
          this.rate_value = convid.rating;
          localStorage.setItem("fchat_has_rate", true);
          localStorage.setItem("fchat_rate_value", convid.rating);
        }
      } else {
        this.loadMessages(convid._id, 0);
        this.view_conv = true;
        this.page = 0;
        this.show_rating = false;
        localStorage.setItem("fchat_show_rating", false);
      }
    },
    backConv() {
      this.convsation_id = "";
      this.clearIntTitle();
      localStorage.removeItem("convsation_id");
      localStorage.removeItem("fchat_show_rating");
      localStorage.removeItem("fchat_has_rate");
      localStorage.removeItem("fchat_rate_value");
      sessionStorage.removeItem("fchat_conv_" + this.id);
      sessionStorage.removeItem("fchat_last_url");
      this.show_rating = false;
      this.has_rate = false;
      this.rate_value = "";
      this.salelists = [];
      localStorage.removeItem("fchat_sale");
      localStorage.removeItem("fchat_sale_avatar");
      this.loadConv();
      if (this.show_salesonline == 1) {
        this.getSalesOnline();
      }
    },
    removeMess() {
      this.clearIntTitle();
      this.preview_conv = [];
      this.list_quick_welcome = [];
      localStorage.setItem("fchat_closed_preview", Date.now());
    },
    sendBlockPreview(button) {
      if (this.chat_now == false) {
        if (button.type == "web_url") {
          window.open(button.url, "_blank");
        } else {
          this.clearIntTitle();
          this.preview_conv = [];
          this.list_quick_welcome = [];
          this.showchat = true;
          sessionStorage.setItem("fchat_showchat", true);
          this.data_quick_delay = button;
        }
      } else {
        if (button.type == "web_url") {
          window.open(button.url, "_blank");
        } else {
          this.clearIntTitle();
          this.preview_conv = [];
          this.list_quick_welcome = [];
          this.showchat = true;
          sessionStorage.setItem("fchat_showchat", true);
          this.createConversation(false, button);
        }
      }
    },
    onChangeImage(e) {
      let files;
      if (e.clipboardData && e.clipboardData.files) {
        files = e.clipboardData.files;
      } else {
        files = e.target.files || e.dataTransfer.files;
      }
      if (!files.length) {
        return;
      } else if (e.clipboardData) {
        e.clipboardData.setData("text/plain", "");
        e.preventDefault();
      }
      this.data_upload_img = files[0];
      this.readFiles(this, files, 0);
    },
    readFiles(vm, files, i) {
      if (files[i]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          let image_base64 = e.target.result;
          if (!vm.img_preview) {
            vm.img_preview = [];
          }
          vm.img_preview.push(image_base64);
          i += 1;
          vm.readFiles(vm, files, i);
        };
        reader.readAsDataURL(files[i]);
      }
    },
    checkLinks(text) {
      var exp =
        /(\b(https?|ftp|file):\/\/([-A-Z0-9+&@#%?=~_|!:,.;]*)([-A-Z0-9+&@#%?\/=~_|!:,.;]*)[-A-Z0-9+&@#\/%=~_|])/gi;
      return text.replace(exp, "<a href='$1' target='_blank'>$1</a>");
    },
    dragstartChat(e) {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return;
      }
      e.preventDefault();
      this.activedrag = true;
      var chatconv = this.$el.querySelector("#chat_converse");
      this.initialX = e.clientX - this.xOffset;
      this.initialY = chatconv.offsetHeight + e.clientY;
    },
    dragChat(e) {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return;
      }
      if (this.activedrag) {
        this.currentX = e.clientX - this.initialX;
        this.currentY = e.clientY - this.initialY;
        this.xOffset = this.currentX;
        this.yOffset = this.currentY;
        var chatbody = this.$el.querySelector("#fchatbody");
        var chatconv = this.$el.querySelector("#chat_converse");
        if (-1 * this.currentY < 600 && -1 * this.currentY > 250) {
          chatconv.style.height = -1 * this.currentY + "px";
        }
        this.setTranslate(this.currentX, chatbody);
      }
    },
    dragendChat(e) {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return;
      }
      this.initialX = this.currentX;
      this.initialY = this.currentY;
      this.activedrag = false;
    },
    setTranslate(xPos, el) {
      el.style.transform = "translateX(" + xPos + "px)";
    },
    uploadImage(event) {
      this.data_upload_img = [];
      this.img_preview = "";
      this.file_preview = "";
      this.send_file = false;
      var input = event.target;
      if (input.files) {
        if (input.files[0].type.includes("image")) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.img_preview = e.target.result;
          };
          reader.readAsDataURL(input.files[0]);
        } else {
          this.send_file = true;
          this.img_preview = "https://cdn.fchat.vn/assets/images/file.svg";
        }
      }
      this.file_preview = input.files[0].name;
      this.data_upload_img = event.target.files[0];
      input.value = "";
    },
    removePreviewimg() {
      this.img_preview = "";
    },
    inputHandler(e) {
      // Highlight the send icon when there is input
      this.$nextTick(() => {
        const fabSend = document.getElementById("fab_send");
        console.log(fabSend, " this.send_text);");
        if (fabSend) {
          if (this.send_text && this.send_text.trim() !== "") {
            fabSend.classList.add("active_send");
          } else {
            fabSend.classList.remove("active_send");
          }
        }
      });
      this.autoHeight();
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        if (window.innerWidth <= 768) {
          // Nếu là màn hình mobile thì xuống dòng
          // Thêm ký tự xuống dòng tại vị trí con trỏ
          const textarea = this.$refs.main_textarea;
          const value = textarea.value;
          const start = textarea.selectionStart;
          const end = textarea.selectionEnd;
          this.send_text = value.substring(0, start) + '\n' + value.substring(end);
          this.$nextTick(() => {
            textarea.selectionStart = textarea.selectionEnd = start + 1;
          });
          return;
        }
        this.beforeSendChat();
      }
      if (e.keyCode === 32 && !e.shiftKey) {
        e.preventDefault();
        const textarea = this.$refs.main_textarea;
        const sentence = textarea.value;
        const len = sentence.length;
        let pos = textarea.selectionStart;
        if (pos === undefined) {
          pos = 0;
        }
        const before = sentence.substr(0, pos);
        const after = sentence.substr(pos, len);
        let value = before + " " + after;
        this.send_text = value;
        if (pos != this.send_text.length - 1) {
          setTimeout(() => {
            textarea.selectionStart = textarea.selectionEnd = pos + 1;
          }, 0);
        }
      }
    },
    inputName(e) {
      if (e.keyCode === 32 && !e.shiftKey) {
        e.preventDefault();
        const textarea = this.$refs.name_input;
        const sentence = textarea.value;
        const len = sentence.length;
        let pos = textarea.selectionStart;
        if (pos === undefined) {
          pos = 0;
        }
        const before = sentence.substr(0, pos);
        const after = sentence.substr(pos, len);
        let value = before + " " + after;
        this.form_name = value;
        if (pos != this.form_name.length - 1) {
          setTimeout(() => {
            textarea.selectionStart = textarea.selectionEnd = pos + 1;
          }, 0);
        }
      }
    },
    sendBlock(button) {
      this.send_text = button.title;
      this.beforeSendChat();
      var id = this.id;
      var convsation_id = this.convsation_id;
      var fchat_userid = this.fchat_userid;
      setTimeout(function () {
        axios
          .post(
            config.API_URL + "webchat/sendblock",
            {
              page_id: id,
              conv_id: convsation_id,
              block_id: button.payload,
              page_type: 2,
              user_id: fchat_userid,
            },
            {
              headers: { "Content-type": "application/json" },
            }
          )
          .catch((e) => {
            console.log(e);
          });
      }, 2000);
    },
    sendQuick(quick) {
      this.send_text = quick.title;
      var quick_next = this.data_quicknext;
      this.beforeSendChat(true, quick._id);
      var id = this.id;
      var convsation_id = this.convsation_id;
      var fchat_userid = this.fchat_userid;
      setTimeout(function () {
        axios
          .post(
            config.API_URL_CLIENT + "webchat/sendQuick",
            {
              _id: quick._id,
              page_id: id,
              conv_id: convsation_id,
              block_id: quick.value,
              keyword_content_id: quick.keyword_content_id,
              page_type: 2,
              quick_value: quick.title,
              user_id: fchat_userid,
              data_quick: quick_next,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .catch((e) => {
            console.log(e);
          });
      }, 1000);
    },
    async sendQuickAssistant(quick) {
      this.send_text = quick.title;
      // console.log( this.send_text);
      var quick_next = this.data_quicknext;
      this.beforeSendChat(true, quick._id);
      if (quick.assistant_id_business) {
        localStorage.setItem("assistant_id", quick.assistant_id_business);
        await this.postthread_id();
        this.socket.emit("user-typing-conversation", {
          conv_id: this.convsation_id,
        });

        var containerTyping = this.$el.querySelector("#typing_chat4");
        containerTyping.style.display = "block";
        setTimeout(() => {
          containerTyping.style.display = "none";
          var object = {
            quick_answer_images: [],
            chat_by: {
              full_name: "Trợ lý GPT",
            },
            //  shop_id: "60ace09f34b97b3fc7480028",
            // _id: "65a5eeb8accfb4375a6d5975",
            // page_id: this.page_id,
            sender_id: "4109217569110237",
            sender_name: "Trợ lý GPT",
            avatar: "https://fchat.co/assets/images/fb-avatar.gif",
            shop_id: this.shop_id,
            updated_at: Date.now(),
            created_at: Date.now(),
            update_status: 0,
            isReadWeb: false,
            isClosed: true,
            isAssign: true,
            isDelete: false,
            is_Page_Response: false,
            isRead: true,
            is_lock: false,
            is_done: false,
            content_type: 2,
            conv_id: this.convsation_id,
            message:
              "Đây là trợ lý trả lời tự động từ Fchat.vn về " +
              quick.title +
              '. Bạn hãy đặt câu hỏi! Gửi tin nhắn "stop" để dừng nhận hỗ trợ từ Trợ lý ảo!',
            page_id: this.id,
            preview_index: "1706607246926_0",
            //recipient_id : "4109217569110237",
            // sender_id: "7079795905445557",
            step: 0,
            video_url: "",
            whisper: false,
            //  user_send: "659b6253a1b1744a872be0c2",
            quick_keyword: false,
            page_avatar: "https://fchat.vn/assets/images/logo/favicon-c.png",
          };

          axios
            .post(config.API_URL + "messages/send", object, {
              headers: {
                "Content-type": "application/json",
                "x-access-token": localStorage.getItem("token_shop"),
              },
            })
            .then((response) => {
              this.socket.emit("receive-message", response.data.data_socket);
            })
            .catch((error) => {
              console.error(error);
            });

          var containerTyping1 = this.$el.querySelector("#typing_chat1");
          containerTyping1.style.display = "none";
          var containerTyping2 = this.$el.querySelector("#typing_chat2");
          containerTyping2.style.display = "none";
        }, 5000);
      }
      this.tunonoffAssistant();
    },
    postthread_id() {
      if (localStorage.getItem("token_shop")) {
        axios
          .post(
            config.API_URL +
            "conversations/update?id=" +
            localStorage.getItem("convsation_id"),
            {
              assistant_id_business: localStorage.getItem("assistant_id"),
            },
            {
              headers: {
                "Content-type": "application/json",
                "X-Access-Token": localStorage.getItem("token_shop"),
              },
            }
          )
          .then((response) => { });
      }
    },
    tunonoffAssistant() {
      axios
        .post(
          config.API_URL +
          "conversations/update?id=" +
          localStorage.getItem("convsation_id"),
          {
            assistant_status: 1,
          },
          {
            headers: {
              "Content-type": "application/json",
              "X-Access-Token": localStorage.getItem("token_shop"),
            },
          }
        )
        .then((response) => { });
    },
    tunoffAssistant() {
      axios
        .post(
          config.API_URL +
          "conversations/update?id=" +
          localStorage.getItem("convsation_id"),
          {
            assistant_status: 0,
          },
          {
            headers: {
              "Content-type": "application/json",
              "X-Access-Token": localStorage.getItem("token_shop"),
            },
          }
        )
        .then((response) => { });
    },


    sendGreating() {
      var id = this.id;
      var convsation_id = this.convsation_id;
      var fchat_userid = this.fchat_userid;
      var block_id = this.block_id_greeting;
      var _this = this;
      setTimeout(function () {
        axios
          .post(
            config.API_URL + "webchat/sendgreeting",
            {
              page_id: id,
              conv_id: convsation_id,
              user_id: fchat_userid,
              block_id: block_id,
              // block_id: "658a8a6b27227c3b8e3a2388" ,
            },
            {
              headers: { "Content-type": "application/json" },
            }
          )
          .then((response) => {
            // console.log(response);
            if (!response.data.error && block_id) {
              if (Array.isArray(_this.fchat_link_block)) {
                for (var i in _this.fchat_link_block) {
                  if (
                    _this.fchat_link_block[i].url ==
                    _this.RemoveParamUrl(window.location.href)
                  ) {
                    _this.fchat_link_block.splice(i, 1);
                  }
                }
                _this.fchat_link_block.push({
                  time: Date.now(),
                  url: _this.RemoveParamUrl(window.location.href),
                });
                localStorage.setItem(
                  "fchat_link_block",
                  JSON.stringify(_this.fchat_link_block)
                );
              } else {
                _this.fchat_link_block = [
                  {
                    time: Date.now(),
                    url: _this.RemoveParamUrl(window.location.href),
                  },
                ];
                localStorage.setItem(
                  "fchat_link_block",
                  JSON.stringify(_this.fchat_link_block)
                );
              }
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }, 0);
    },
    beforeSendChat(quick = false, quick_id = "") {
      if (this.convsation_id == "ready") {
        this.createConversation(true);
      } else {
        this.sendChat(quick, quick_id);
      }
    },
    async sendChat(quick = false, quick_id = "") {
      //console.log('id block', this);

      if (!this.send_text && !this.img_preview) {
        return;
      }
      let time = new Date().getTime();
      if (time - this.last_send > 1000) {
        this.last_send = time;
      } else {
        alert("Bạn gửi tin quá nhanh! Vui lòng thử lại sau 1s");
        return;
      }
      var ntext = this.send_text;
      try {
        this.send_text = "";
        this.data_quickshow = [];
        this.data_assistantshow = [];
        this.data_quicknext = [];
        if (this.show_rating) {
          localStorage.removeItem("fchat_show_rating");
          localStorage.removeItem("fchat_has_rate");
          localStorage.removeItem("fchat_rate_value");
          this.show_rating = false;
          this.has_rate = false;
          this.rate_value = "";
        }
        if (this.img_preview) {
          if (ntext) {
            let push_message = {
              _id: time + "_" + 0,
              sender: {
                sender_name: "",
                sender_id: "",
              },
              is_Page_Reply: false,
              message: ntext,
              status: 0,
              page_id: this.id,
              updated_at: time,
            };
            this.messages.push(push_message);
            let data_send = {
              page_id: this.id,
              conv_id: this.convsation_id,
              message: ntext,
              quick: quick,

              preview_index: time + "_" + 0,
              m_id: Date.now(),
            };
            if (quick_id) {
              data_send.quick_id = quick_id;
            }
            await axios
              .post(config.API_URL + "webchat/send", data_send, {
                headers: { "Content-type": "application/json" },
              })

              .then((response) => {
                localStorage.removeItem("data_quicknext");
                localStorage.removeItem("data_quickshow");
                localStorage.removeItem("data_assistantshow");
                this.socket.emit("webchat", response.data.data_socket);
                this.messages.find((o, i) => {
                  if (o._id == response.data.preview_index) {
                    this.messages[i].status = 1;
                    this.MessStorage(response.data.data_socket.message);
                    return true;
                  }
                });
              })
              .catch((e) => {
                console.log(e);
              });
          }
          //upload image
          let data = new FormData();
          data.append("file", this.data_upload_img);
          data.append("conv_id", this.convsation_id);
          const check_invalid = await helpers.checkValidFileUpload(this.data_upload_img)
          if (!check_invalid) {
            this.messages.push({
              message: this.data_upload_img.name,
              status: 2,
              page_id: this.id,
              updated_at: time,
            });
            this.img_preview = "";
            this.file_preview = "";
            this.data_upload_img = [];
            return;
          }
          let url_upload;
          if (!this.send_file) {
            url_upload = config.API_URL_CLIENT + "webchat/do_upload";
          } else {
            url_upload = config.API_URL_CLIENT + "webchat/do_uploadfile";
            this.messages.push({
              message: this.data_upload_img.name,
              status: 3,
              page_id: this.id,
              updated_at: time,
            });
            setTimeout(this.scrollToEnd, 10);
          }
          this.img_preview = "";
          this.file_preview = "";
          this.data_upload_img = [];
          axios
            .post(url_upload, data, {
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              let push_message = {
                _id: time + "_" + 1,
                sender: {
                  sender_name: "",
                  sender_id: "",
                },
                is_Page_Reply: false,
                message: "",
                status: 0,
                page_id: this.id,
                updated_at: time,
              };
              if (this.send_file) {
                push_message.attachments = [
                  {
                    size: response.data.data.file_size,
                    url:
                      config.BASE_URL +
                      "public/tmp/file/" +
                      this.convsation_id +
                      "/" +
                      response.data.data.file_name,
                    name: response.data.data.client_name,
                  },
                ];
                this.messages.pop();
              } else {
                push_message.albums = [
                  config.BASE_URL +
                  "public/images/webchat/" +
                  response.data.data.file_name,
                ];
              }
              if (response.data.data.file_name) {
                this.messages.push(push_message);

                let data_post = {
                  page_id: this.id,
                  conv_id: this.convsation_id,
                  message: "",
                  quick: quick,
                  preview_index: time + "_" + 1,
                  m_id: Date.now(),
                };
                if (this.send_file) {
                  data_post.attachments = {
                    size: response.data.data.file_size,
                    url:
                      config.BASE_URL +
                      "public/tmp/file/" +
                      this.convsation_id +
                      "/" +
                      response.data.data.file_name,
                    name: response.data.data.client_name,
                  };
                } else {
                  data_post.image =
                    config.BASE_URL +
                    "public/images/webchat/" +
                    response.data.data.file_name;
                }
                axios
                  .post(config.API_URL + "webchat/send", data_post, {
                    headers: { "Content-type": "application/json" },
                  })
                  .then((response) => {
                    localStorage.removeItem("data_quicknext");
                    localStorage.removeItem("data_quickshow");
                    localStorage.removeItem("data_assistantshow");
                    this.socket.emit("webchat", response.data.data_socket);
                    this.messages.find((o, i) => {
                      if (o._id == response.data.preview_index) {
                        this.messages[i].status = 1;
                        this.MessStorage(response.data.data_socket.message);
                        return true;
                      }
                    });
                  });
              } else {
                this.messages.push({
                  message: response.data.data.replace(/<[^>]*>?/gm, ""),
                  status: 2,
                  page_id: this.id,
                  updated_at: time,
                });
              }
              setTimeout(this.scrollToEnd, 500);
            });
        } else {
          let push_message = {
            _id: time + "_" + 0,
            sender: {
              sender_name: "",
              sender_id: "",
            },
            is_Page_Reply: false,
            message: ntext,
            status: 0,
            page_id: this.id,
            updated_at: time,
          };
          this.messages.push(push_message);
          let data_send = {
            page_id: this.id,
            conv_id: this.convsation_id,
            message: ntext,
            quick: quick,
            preview_index: time + "_" + 0,
            m_id: Date.now(),
          };
          if (quick_id) {
            data_send.quick_id = quick_id;
          }
          await axios
            .post(config.API_URL + "webchat/send", data_send, {
              headers: { "Content-type": "application/json" },
            })

            .then((response) => {
              if (!response.data.error) {
                if (this.data_userinputnext) {
                  axios
                    .post(
                      config.API_URL + "webchat/sendinput",
                      {
                        page_id: this.id,
                        conv_id: this.convsation_id,
                        message: ntext,
                        data_userinputnext: this.data_userinputnext,
                      },
                      {
                        headers: {
                          "Content-Type": "application/json",
                        },
                      }
                    )
                    .then((response) => {
                      if (response.data.input_data) {
                        if (response.data.input_data.validate) {
                          localStorage.removeItem("data_userinputnext");
                          this.data_userinputnext = "";
                        } else {
                          if (response.data.input_data.stop_block == "1") {
                            localStorage.removeItem("data_userinputnext");
                            this.data_userinputnext = "";
                          }
                        }
                      }
                    });
                }

                localStorage.removeItem("data_quicknext");
                localStorage.removeItem("data_quickshow");
                localStorage.removeItem("data_assistantshow");

                this.messages.find((o, i) => {
                  if (o._id == response.data.preview_index) {
                    this.messages[i].status = 1;
                    if (localStorage.getItem(this.convsation_id)) {
                      var messages = JSON.parse(
                        localStorage.getItem(this.convsation_id)
                      );
                      messages.push(response.data.data_socket.message);

                      localStorage.setItem(
                        this.convsation_id,
                        JSON.stringify(messages)
                      );
                    } else {
                      localStorage.setItem(
                        this.convsation_id,
                        JSON.stringify(response.data.data_socket.message)
                      );
                    }
                    // this.MessStorage(response.data.data_socket.message);
                    return true;
                  }
                });

                this.socket.emit("webchat", response.data.data_socket);
              }
            })
            .catch((e) => {
              console.log(e);
              this.messages[this.messages.length - 1].status = 2;
              return true;
            });
        }

        setTimeout(this.scrollToEnd, 500);
        //lay ra trang thai trong db
        // await axios
        //   .get(
        //     config.API_URL +
        //       "conversations/detail?id=" +
        //       localStorage.getItem("convsation_id"),
        //     {
        //       headers: {
        //         "Content-type": "application/json",
        //         "x-access-token": localStorage.getItem("token_shop"),
        //       },
        //     }
        //   )
        //   .then((response) => {
        //     localStorage.setItem(
        //       "assistant_status_1",
        //       response.data.data_conv.assistant_status
        //     );
        //   });

        if (ntext && ntext.toLowerCase() !== "stop chatgpt") {
          let id_troly = localStorage.getItem("assistant_id");

          //let id_troly = 'asst_CjuuR5ESp4TrNhNdPEKe8jmw';
          // let id_chude = 'thread_F30sFIn6TreyX7gOvwYzya05';

          // var allConversationInfos = JSON.parse(localStorage.getItem('conversationInfoList'));
          // var convsationIdToSearch = localStorage.getItem('convsation_id');
          // var matchingInfos = allConversationInfos.filter(info => info.convsation_id === convsationIdToSearch);
          if (
            localStorage.getItem("assistant_status_1") == 1 &&
            id_troly !== null &&
            localStorage.getItem("token_gpt_assistant") !== null
          ) {
            //typing cho phan hoi
            var containerTyping = this.$el.querySelector("#typing_chat1");
            containerTyping.style.display = "block";
            setTimeout(() => {
              containerTyping.style.display = "none";
            }, 60000);


            this.socket.emit("user-typing-conversation", {
              conv_id: this.convsation_id,
            });

            //var containerTyping1 = this.$el.querySelectorAll("#typing_chat1");

            var containerTyping = this.$el.querySelector("#typing_chat1");

            containerTyping.style.display = "block";
            //containerTyping1.style.display = 'block';
            setTimeout(() => {
              containerTyping.style.display = "none";
              //containerTyping1.style.display = 'none';
            }, 60000);

            //console.log(userQuestion);
          }
        }
      } catch (error) {
        console.error("Error calling sendassistantapi:", error);
      }
    },
    ScrollMessage(event) {
      if (!this.view_conv) {
        return false;
      }
      let chat_height = this.$el.querySelector("#chat_converse");
      let mess_height = this.$el.querySelector("#scroll_mess").clientHeight;
      if (event.target.scrollTop == 0) {
        this.loadMessages(this.convsation_id, this.page, false, true);
        setTimeout(chat_height.scroll(0, 400), 500);
        this.page++;
      }
    },
    handlerMess(messagesdata, scroll) {
      var cd = messagesdata;
      cd.sort(function (a, b) {
        var dateA = new Date(a.created_at);
        var dateB = new Date(b.created_at);
        return dateB - dateA;
      });
      localStorage.setItem(this.convsation_id, JSON.stringify(cd));
      for (var key in messagesdata) {
        var check_mess = 0;
        var value = messagesdata;
        var nkey = parseInt(key) - 1;
        if (nkey < 0) {
          nkey = "";
        } else if (nkey == 0) {
          if (value[nkey].is_Page_Reply == true) {
            nkey = "first";
          }
        }
        if (value[key].is_Page_Reply == true) {
          if (nkey == "") {
            check_mess = 0;
          } else if (nkey == "first") {
            check_mess = 1;
          } else {
            if (typeof value[nkey].chat_by != "undefined") {
              check_mess++;
            } else {
              check_mess = 0;
            }
          }
        }
        if (check_mess > 0) {
          value[key].none_avatar = true;
        }
        this.messages.unshift(value[key]);
      }
      if (messagesdata.length < this.page_limit) {
        this.view_conv = false;
      }
      if (!scroll) {
        setTimeout(this.scrollToEnd, 100);
      }
    },
    loadMessages(conv_id, page, isdone = false, scroll = false) {
      var localConvid =
        typeof window !== "undefined" ? localStorage.getItem(conv_id) : null;
      if (localConvid && JSON.parse(localStorage.getItem(conv_id)).length > 0) {
        let npage = parseInt(page) + 1;
        var url_request = "";

        url_request =
          config.API_URL +
          "webchat/getmessage?conv_id=" +
          conv_id +
          "&page=" +
          npage +
          "&paging=" +
          this.page_limit +
          "";
        axios
          .get(url_request, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            let checkLength = JSON.parse(localStorage.getItem(conv_id));
            var container_typing1 = this.$el.querySelector("#typing_chat1");
            // container_typing1.style.display = 'block';
            container_typing1.style.display = "none";
            var container_typing4 = this.$el.querySelector("#typing_chat4");
            //container_typing4.style.display = 'block';
            container_typing4.style.display = "none";
            var container_typing = this.$el.querySelector("#typing_chat2");
            // container_typing.style.display = 'block';
            container_typing.style.display = "none";
            if (checkLength.length < response.data.messages.length) {
              var messagesdata = response.data.messages;
              if (response.data.messages) {
                localStorage.setItem(conv_id, JSON.stringify(messagesdata));
              }
              this.handlerMess(messagesdata, scroll);
            } else {
              this.handlerMess(JSON.parse(localConvid), scroll);
            }
          });
      } else {
        let npage = parseInt(page) + 1;
        var url_request = "";

        url_request =
          config.API_URL +
          "webchat/getmessage?conv_id=" +
          conv_id +
          "&page=" +
          npage +
          "&paging=" +
          this.page_limit +
          "";
        axios
          .get(url_request, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            if (response.data.isDone) {
              this.backConv();
              return;
            }
            var messagesdata = response.data.messages;

            if (response.data.messages) {
              localStorage.setItem(conv_id, JSON.stringify(messagesdata));
            }

            this.handlerMess(messagesdata, scroll);
          });
      }
    },
    loadConv() {
      if (sessionStorage.getItem("fchat_conv_" + this.id)) {
        this.conversations = JSON.parse(
          sessionStorage.getItem("fchat_conv_" + this.id)
        );
      } else {
        axios
          .get(
            config.API_URL +
            "webchat/getconvsation?sender_id=" +
            this.fchat_userid +
            "",
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            if (!response.data.error) {
              this.conversations = [];
              for (var key in response.data.conv) {
                if (response.data.conv[key].isReadWeb == false) {
                  this.unread_count++;
                  this.siteTitle();
                }
                this.conversations.push(response.data.conv[key]);
              }
              sessionStorage.setItem(
                "fchat_conv_" + this.id,
                JSON.stringify(this.conversations)
              );
            }
          });
      }
    },
    viewAllConv() {
      if (this.show_convnum == 3) {
        this.show_convnum = 1000;
        if (this.language == "english") {
          this.text_convall = "Collapse";
        } else {
          this.text_convall = "Thu gọn";
        }
      } else {
        if (this.language == "english") {
          this.text_convall = "View all";
        } else {
          this.text_convall = "Xem tất cả";
        }
        this.show_convnum = 3;
      }
    },
    openChat(type_open = '') {
      this.list_quick_welcome = [];
      this.currentX = null;
      this.currentY = null;
      this.initialX = null;
      this.initialY = null;
      this.xOffset = 0;
      this.yOffset = 0;
      var chatbody = this.$el.querySelector("#fchatbody");
      chatbody.style.transform = "translateX(0)";
      localStorage.setItem("fchat_unread_count", 0);
      this.clearIntTitle();
      if (this.showchat == true) {
        this.showchat = false;
        this.webAction(3);
        sessionStorage.setItem("fchat_showchat", false);
      } else {
        if (
          this.chat_now &&
          this.preview_conv.length > 0 &&
          !this.convsation_id && !type_open
        ) {
          this.createConversation();
        }
        if (
          this.show_salesonline == 1 &&
          !this.convsation_id &&
          this.salesonline.length == 0
        ) {
          this.getSalesOnline();
        }
        if (
          this.is_login &&
          !this.convsation_id &&
          this.conversations.length == 0
        ) {
          this.loadConv();
        }
        this.webAction(4);
        this.showchat = true;
        sessionStorage.setItem("fchat_showchat", true);
        setTimeout(this.scrollToEnd, 100);
      }
      this.preview_conv = [];
    },
    closeChat() {
      this.showchat = false;
      sessionStorage.setItem("fchat_showchat", false);
    },
    validEmail: function (email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    scrollToEnd: function () {
      var container_message = this.$el.querySelector("#chat_converse");
      if (container_message) {
        container_message.scroll(0, container_message.scrollHeight);
      }
    },
    autoHeight() {
      var eltext = this.$el.querySelector("#chatSend");
      var text_height = this.$el.querySelector("#chatsend_height");
      text_height.style.height = 0 + "px";
      text_height.style.height = eltext.scrollHeight - 10 + "px";
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    showDateDetail(time) {
      if (typeof time == "undefined") {
        time = new Date();
      }
      if (
        this.setFormatDate("DDMMYYYY", time) ==
        this.setFormatDate("DDMMYYYY", new Date())
      ) {
        return this.setFormatDate("HH:mm", time);
      } else {
        if (
          this.setFormatDate("YYYY", time) ==
          this.setFormatDate("YYYY", new Date())
        ) {
          return this.setFormatDate("DD/MM HH:mm", time);
        } else {
          return this.setFormatDate("DD/MM/YYYY HH:mm", time);
        }
      }
    },
    setFormatDate(format, value) {
      if (value) {
        return moment(String(value)).format(format);
      }
    },
    nToBr(text) {
      if (text) {
        text = text
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#039;");
        text = text.replace(/\n/g, "<br>");
        return this.checkLinks(text);
      }
    },
    getSalesOnline() {
      this.salesonline = [];
      axios
        .post(
          config.API_URL + "webchat/useronline",
          { page_id: this.id },
          {
            headers: { "Content-type": "application/json" },
          }
        )
        .then((response) => {
          for (var key in response.data.user_online_list) {
            var value = response.data.user_online_list;
            if (value[key].id != "") {
              this.salesonline.push(value[key]);
            }
          }
        });
    },
    sendRating(value) {
      axios
        .post(
          config.API_URL_CLIENT + "webchat/sendRating",
          {
            page_id: this.id,
            convsation_id: this.convsation_id,
            rating: value,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (!response.data.error) {
            this.has_rate = true;
            this.rate_value = value;
            localStorage.setItem("fchat_has_rate", true);
            localStorage.setItem("fchat_rate_value", value);
          }
        });
    },
    updateRead(conv) {
      axios
        .post(
          config.API_URL + "webchat/updateread",
          { convsation_id: conv, is_read: true },
          {
            headers: { "Content-type": "application/json" },
          }
        )
        .then((response) => {
          if (!response.data.error) {
          }
        });
    },

    openGreeting() {
      if (!this.showchat) {
        if (!this.fchat_userid) {
          var default_message =
            "Chào mừng bạn ghé thăm page. Hãy gửi cho chúng tôi bất kỳ câu hỏi nào của bạn.Thanks for getting in touch with us. Please send us any questions you may have.";
          if (this.block_id_greeting) {
            axios
              .get(
                config.API_URL_CLIENT +
                "webchat/getBlockContents?page_id=" +
                this.id +
                "&block_id=" +
                this.block_id_greeting,
                {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                  },
                }
              )
              .then((response) => {
                console.log(response);
                if (!response.data.error) {
                  if (this.first_mess) {
                    var _this = this;
                    setTimeout(function () {
                      if (!_this.showchat) {
                        if (response.data.data.text) {
                          default_message = response.data.data.text;
                          if (response.data.data.buttons) {
                            _this.list_quick_welcome =
                              response.data.data.buttons;
                          }
                        }

                        let data_preview = {
                          message: default_message,
                        };
                        _this.unread_count++;
                        _this.siteTitle();
                        _this.preview_conv.push(data_preview);
                      }
                    }, _this.first_mess_time * 1000);
                  }
                }
              });
          } else {
            var time_check = Date.now() - this.closed_preview;
            var time_set = this.first_mess_retime * 3600 * 1000;
            if (time_check > time_set) {
              if (this.welcome_data) {
                if (this.first_mess) {
                  var _this = this;
                  setTimeout(function () {
                    if (!_this.showchat) {
                      if (_this.welcome_data.text) {
                        default_message = _this.welcome_data.text;
                        if (_this.welcome_data.buttons) {
                          _this.list_quick_welcome = _this.welcome_data.buttons;
                        }
                      }
                      let data_preview = {
                        message: default_message,
                      };
                      _this.unread_count++;
                      _this.siteTitle();
                      _this.preview_conv.push(data_preview);
                    }
                  }, _this.first_mess_time * 1000);
                }
              }
            }
          }
        }
      }
    },
    RemoveParamUrl(url) {
      var fragment = url.split("#");
      var urlparts = fragment[0].split("?");
      return urlparts[0];
    },
    checkRef(dataref) {
      var _this = this;
      var block_id = "";
      var check_send_block = false;
      if (!_this.fchat_link_block) {
        check_send_block = true;
      } else {
        for (var i in _this.fchat_link_block) {
          if (
            JSON.stringify(_this.fchat_link_block).includes(
              _this.RemoveParamUrl(window.location.href)
            )
          ) {
            var time_check = Date.now() - _this.fchat_link_block[i].time;
            if (
              _this.fchat_link_block[i].url ==
              _this.RemoveParamUrl(window.location.href) &&
              time_check > 86400000
            ) {
              check_send_block = true;
            }
          } else {
            check_send_block = true;
          }
        }
      }

      if (dataref.length > 0) {
        for (var i in dataref) {
          var domain_url = new URL(window.location.href);

          var pathdomain = domain_url.pathname;
          if (dataref[i].rule == "--" && pathdomain.replace("/", "") == "") {
            block_id = dataref[i].block_id;
          } else if (pathdomain.includes(dataref[i].rule)) {
            block_id = dataref[i].block_id;
          }
        }
      }

      var id = this.id;
      var convsation_id = this.convsation_id;
      var fchat_userid = this.fchat_userid;
      this.block_id_greeting = block_id;
      this.openGreeting();
      if (block_id && check_send_block && this.convsation_id) {
        setTimeout(function () {
          axios
            .post(
              config.API_URL + "webchat/sendblock",
              {
                page_id: id,
                conv_id: convsation_id,
                block_id: block_id,
                page_type: 2,
                user_id: fchat_userid,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {
              if (!response.data.error) {
                if (Array.isArray(_this.fchat_link_block)) {
                  for (var i in _this.fchat_link_block) {
                    if (
                      _this.fchat_link_block[i].url ==
                      _this.RemoveParamUrl(window.location.href)
                    ) {
                      _this.fchat_link_block.splice(i, 1);
                    }
                  }
                  _this.fchat_link_block.push({
                    time: Date.now(),
                    url: _this.RemoveParamUrl(window.location.href),
                  });
                  localStorage.setItem(
                    "fchat_link_block",
                    JSON.stringify(_this.fchat_link_block)
                  );
                } else {
                  _this.fchat_link_block = [
                    {
                      time: Date.now(),
                      url: _this.RemoveParamUrl(window.location.href),
                    },
                  ];
                  localStorage.setItem(
                    "fchat_link_block",
                    JSON.stringify(_this.fchat_link_block)
                  );
                }
              }
            })
            .catch((e) => {
              console.log(e);
            });
        }, 1000);
      }
    },
    sendAction(type) {
      if (type == 3 || type == 4) {
        axios
          .post(
            config.API_URL + "webchat/updatestatus",
            {
              page_id: this.id,
              convsation_id: this.convsation_id,
              type: type,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            if (!response.data.error) {
              this.socket.emit("webchat-page-view", {
                conv_id: this.convsation_id,
                page_id: this.id,
                type: type,
              });
            }
          });
      } else {
        axios
          .post(
            config.API_URL + "webchat/webaction",
            {
              page_id: this.id,
              convsation_id: this.convsation_id,
              type: type,
              sender_id: this.fchat_userid,
              url: window.location.href,
              title: this.site_Title,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            if (!response.data.error) {
              this.socket.emit("webchat-page-view", {
                conv_id: this.convsation_id,
                page_id: this.id,
                type: type,
                data: response.data.data_socket,
              });
            }
          });
      }
    },
    plusSlides(n, index, j, action) {
      let i;
      for (i = 0; i < n; i++) {
        this.$el.querySelector(".mySlides" + index + i).style.display = "none";
        this.$el.querySelector(
          ".mySlides" + index + i + " .next"
        ).style.opacity = "1";
        this.$el.querySelector(
          ".mySlides" + index + i + " .next"
        ).style.pointerEvents = "auto";
        this.$el.querySelector(
          ".mySlides" + index + i + " .prev"
        ).style.opacity = "1";
        this.$el.querySelector(
          ".mySlides" + index + i + " .prev"
        ).style.pointerEvents = "auto";
      }
      let newi;
      if (action) {
        newi = j + 1;
        if (newi >= n - 1) {
          //newi = 0;
          this.$el.querySelector(
            ".mySlides" + index + newi + " .next"
          ).style.opacity = ".5";
          this.$el.querySelector(
            ".mySlides" + index + newi + " .next"
          ).style.pointerEvents = "none";
        }
      } else {
        newi = j - 1;
        if (newi <= 0) {
          this.$el.querySelector(
            ".mySlides" + index + newi + " .prev"
          ).style.opacity = ".5";
          this.$el.querySelector(
            ".mySlides" + index + newi + " .prev"
          ).style.pointerEvents = "none";
        }
      }
      this.$el.querySelector(".mySlides" + index + newi).style.display =
        "block";
    },
    webAction(type) {
      if (!this.convsation_id | this.check_done) {
        return;
      }
      if (type == 1) {
        if (
          sessionStorage.getItem("fchat_last_url") !=
          this.RemoveParamUrl(window.location.href)
        ) {
          var _this = this;
          setTimeout(function () {
            _this.sendAction(type);
            sessionStorage.setItem(
              "fchat_last_url",
              _this.RemoveParamUrl(window.location.href)
            );
          }, 2000);
        }
      } else {
        this.sendAction(type);
      }
    },

    pingToServer() {
      axios
        .post(
          config.API_URL + "webchat/sendping",
          { convsation_id: this.convsation_id, pingtime: Date.now() },
          {
            headers: { "Content-type": "application/json" },
          }
        )
        .then((response) => {
          if (!response.data.error) {
          }
        });
    },
    initPage(data_page) {
      //console.log(this.pageData.settings.icon_hieght)
      //crm cookie
      if (data_page.settings.crm_status == 1) {
        if (data_page.settings.crm_link && data_page.settings.crm_cookie) {
          this.crm_url =
            data_page.settings.crm_link +
            this.getCookie(data_page.settings.crm_cookie);
        }
        if (
          data_page.settings.email_cookie &&
          this.getCookie(data_page.settings.email_cookie)
        ) {
          this.form_email = decodeURIComponent(
            this.getCookie(data_page.settings.email_cookie)
          );
        }
        if (
          data_page.settings.phone_cookie &&
          this.getCookie(data_page.settings.phone_cookie)
        ) {
          this.form_phone = decodeURIComponent(
            this.getCookie(data_page.settings.phone_cookie)
          );
        }
        if (
          data_page.settings.name_cookie &&
          this.getCookie(data_page.settings.name_cookie)
        ) {
          this.form_name = decodeURIComponent(
            this.getCookie(data_page.settings.name_cookie)
          );
        }
      } else {
        if (this.crmid) {
          this.crm_url = "https://fchat.vn/cms/user/" + this.crmid;
        }
        this.form_name = this.name;
        this.form_email = this.email;
        this.form_phone = this.phone;
      }
      var localfchat_pageid =
        typeof window !== "undefined"
          ? localStorage.getItem("fchat_page_id")
          : null;
      this.web_name = data_page.page.name;
      this.icon = data_page.settings.icon
      this.title_contact_social = data_page.settings.title_contact_social;
      this.contact_social = data_page.settings.contact_social;
      if (data_page.settings.contact_social) {
        var check_phone = JSON.stringify(data_page.settings.contact_social);
        if (check_phone.includes("phone")) {
          this.phone_number = data_page.settings.contact_social.phone.url;
        }
      }
      var promenu = [];

      this.menus = data_page.menu;
      if (this.menus.length > 0) {
        for (var key in this.menus) {
          if (this.menus[key]["is_pro"] == 1) {
            promenu = this.menus[key];
            this.menus.splice(
              this.menus.findIndex((el) => el.is_pro == 1),
              1
            );
          }
        }
      }
      if (promenu.is_pro) {
        this.menus.push(promenu);
      }
      this.web_logo = data_page.page.avatar;
      this.form_field = data_page.settings.form_field;
      this.maincolor = data_page.settings.main_color;
      this.welcome_txt = data_page.settings.welcome;
      this.button_start = data_page.settings.button_start;
      this.widget_style = data_page.settings.widget_style;
      this.widget_text = data_page.settings.widget_text;
      this.language = data_page.settings.language_page;
      this.allowdrag = data_page.settings.allowdrag;
      this.show_salesonline = data_page.settings.sale_online;
      this.page_cookies = data_page.page.cookies;

      this.text_newconv =
        this.language == "english" ? "New conversation" : "Đã tạo hội thoại";
      this.text_formname =
        this.language == "english" ? "Your name" : "Tên của bạn";
      this.text_formemail =
        this.language == "english" ? "Your email" : "Email của bạn";
      this.text_formphone =
        this.language == "english" ? "Phone" : "Số điện thoại";
      this.text_formmess =
        this.language == "english" ? "Type something..." : "Viết gì đó";
      this.text_convlist =
        this.language == "english"
          ? "List of conversations"
          : "Danh sách cuộc chat";
      this.text_convall =
        this.language == "english" ? "View all" : "Xem tất cả";
      this.text_convopen = this.language == "english" ? "Open" : "Đang mở";
      this.text_convclose = this.language == "english" ? "Close" : "Đã đóng";
      this.text_convwating =
        this.language == "english" ? "Waiting" : "Chờ trả lời";
      this.text_newchat =
        this.language == "english" ? "New conversation" : "Phiên chat mới";
      this.text_newmessage =
        this.language == "english"
          ? "You have new message!"
          : "Bạn có tin nhắn mới!";
      this.text_convhasclose =
        this.language == "english"
          ? "The conversation is closed"
          : "Hội thoại đã kết thúc";
      this.text_reviewconv =
        this.language == "english"
          ? "Rate this conversation"
          : "Đánh giá phiên hỗ trợ";
      this.text_reviewdes =
        this.language == "english"
          ? "How do you rate this support session?"
          : "Bạn đánh giá thế nào về phiên hỗ trợ này?";
      this.text_reviewthank =
        this.language == "english"
          ? "Thank you for rating"
          : "Cảm ơn bạn đã đánh giá";
      this.text_reviewthankdes =
        this.language == "english"
          ? "Stay connected with us whenever you need it"
          : "Hãy luôn kết nối với chúng tôi mọi lúc bạn cần nhé";
      if (data_page.settings.text_color == 1) {
        this.font_color = "#ffffff";
      } else {
        this.font_color = "#111111";
      }
      if (data_page.settings.position_widget == 2) {
        this.position_widget = 2;
      } else {
        this.position_widget = 1;
      }
      if (data_page.settings.poweredby == 1) {
        this.hide_PoweredBy = 1;
      } else {
        this.hide_PoweredBy = 0;
      }
      this.space_bottom_pc = data_page.settings.space_bottom_pc;
      this.space_bottom_mobile = data_page.settings.space_bottom_mobile;
      this.space_right_mobile = data_page.settings.space_right_mobile;
      this.space_right_pc = data_page.settings.space_right_pc;
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.space_bottom_pc = data_page.settings.space_bottom_mobile;
        this.space_right_pc = data_page.settings.space_right_mobile;
      } else {
        this.space_bottom_pc = data_page.settings.space_bottom_pc;
        this.space_right_pc = data_page.settings.space_right_pc;
      }

      if (localfchat_pageid != data_page.page._id) {
        localStorage.removeItem("fchat_userid");
        localStorage.removeItem("convsation_id");
        localStorage.removeItem("fchat_login");
        localStorage.removeItem("fchat_page_id");
      }
      var localfchat_userid =
        typeof window !== "undefined"
          ? localStorage.getItem("fchat_userid")
          : null;
      var localfchat_userinput =
        typeof window !== "undefined"
          ? localStorage.getItem("data_userinputnext")
          : null;
      var localfchat_quickshow =
        typeof window !== "undefined"
          ? localStorage.getItem("data_quickshow")
          : null;
      var localfchat_assistantshow =
        typeof window !== "undefined"
          ? localStorage.getItem("data_assistantshow")
          : null;
      var localfchat_quicknext =
        typeof window !== "undefined"
          ? localStorage.getItem("data_quicknext")
          : null;
      var localfchat_webform =
        typeof window !== "undefined"
          ? localStorage.getItem("webform_" + this.id)
          : null;
      var localconvsation_id =
        typeof window !== "undefined"
          ? localStorage.getItem("convsation_id")
          : null;
      var localfchat_login =
        typeof window !== "undefined"
          ? localStorage.getItem("fchat_login")
          : null;
      var localshow_rating =
        typeof window !== "undefined"
          ? localStorage.getItem("fchat_show_rating")
          : null;
      var local_has_rate =
        typeof window !== "undefined"
          ? localStorage.getItem("fchat_has_rate")
          : null;
      var local_rate_value =
        typeof window !== "undefined"
          ? localStorage.getItem("fchat_rate_value")
          : null;
      var local_fchat_sale =
        typeof window !== "undefined"
          ? localStorage.getItem("fchat_sale")
          : null;
      var local_fchat_sale_avatar =
        typeof window !== "undefined"
          ? localStorage.getItem("fchat_sale_avatar")
          : null;
      var local_fchat_unread_count =
        typeof window !== "undefined"
          ? localStorage.getItem("fchat_unread_count")
          : null;
      var local_fchat_link =
        typeof window !== "undefined"
          ? localStorage.getItem("fchat_link_block")
          : null;
      var local_fchat_closed_preview =
        typeof window !== "undefined"
          ? localStorage.getItem("fchat_closed_preview")
          : null;
      if (local_fchat_closed_preview != "") {
        this.closed_preview = JSON.parse(local_fchat_closed_preview);
      }
      if (localfchat_userinput != "") {
        this.data_userinputnext = JSON.parse(localfchat_userinput);
      }
      if (local_fchat_link != "") {
        this.fchat_link_block = JSON.parse(local_fchat_link);
      }
      if (localfchat_quickshow != "") {
        var json_quickshow = JSON.parse(localfchat_quickshow);
        for (var i in json_quickshow) {
          this.data_quickshow.push(json_quickshow[i]);
        }
      }
      if (localfchat_assistantshow != "") {
        var json_assistantshow = JSON.parse(localfchat_assistantshow);
        if (json_quickshow) {
          for (var i in json_quickshow) {
            this.data_assistantshow.push(json_assistantshow[i]);
          }
        }
      }
      if (localfchat_quicknext != "") {
        this.data_quicknext = JSON.parse(localfchat_quicknext);
      }
      if (localfchat_webform != "") {
        this.data_webform = JSON.parse(localfchat_webform);
      }
      if (localfchat_userid != "") {
        this.fchat_userid = localfchat_userid;
      }
      if (localconvsation_id) {
        this.convsation_id = localconvsation_id;
      }
      if (localfchat_login == "true") {
        this.is_login = true;
      }
      for (var key in this.form_field) {
        if (this.form_field[key]["enable"] == 1) {
          this.chat_now = false;
        }
      }
      if (this.chat_now) {
        this.is_login = true;
      }
      if (localshow_rating == "true") {
        this.show_rating = true;
      }
      if (local_has_rate == "true") {
        this.has_rate = true;
      }
      if (local_rate_value) {
        this.rate_value = local_rate_value;
      }
      if (sessionStorage.getItem("fchat_showchat") == "true") {
        this.showchat = true;
      } else {
        this.showchat = false;
      }

      if (local_fchat_unread_count > 0) {
        this.unread_count = local_fchat_unread_count;
      }
      if (local_fchat_sale) {
        this.salelists.push({
          avatar: local_fchat_sale_avatar,
          full_name: local_fchat_sale,
        });
      } else {
        this.salelists = [];
      }
      if (this.convsation_id) {
        this.loadMessages(this.convsation_id, 0);

        var _this = this;
        setInterval(function () {
          _this.pingToServer();
          sessionStorage.setItem("fchat_last_url", "");
        }, 60000 * 5);
      } else {
        if (this.is_login && this.showchat) {
          this.loadConv();
        }
      }
      if (data_page.settings.first_mess == 1) {
        if (data_page.settings.first_mess_time) {
          this.first_mess_time = data_page.settings.first_mess_time;
        }
        if (data_page.settings.first_mess_retime) {
          this.first_mess_retime = data_page.settings.first_mess_retime;
        }
      } else {
        this.first_mess = false;
      }
      this.welcome_data = data_page.welcome;
      this.checkRef(data_page.ref);
      if (this.show_salesonline == 1 && this.showchat && !this.convsation_id) {
        this.getSalesOnline();
      }
      this.webAction(1);

      this.is_loaded = true;
    },
    MessStorage(message) {
      if (sessionStorage.getItem("fchat_messages_" + this.id)) {
        let getMess = JSON.parse(
          sessionStorage.getItem("fchat_messages_" + this.id)
        );
        if (getMess.length > 19) {
          getMess.pop();
        }
        getMess.unshift(message);
        sessionStorage.setItem(
          "fchat_messages_" + this.id,
          JSON.stringify(getMess)
        );
      }
    },
    clearIntTitle() {
      this.unread_count = 0;
      clearInterval(this.titleLoop);
      document.title = this.site_Title;
    },
    siteTitle() {
      if (this.has_clicked) {
        // var audio = new Audio('https://cdn.fchat.vn/assets/embed/sound.mp3');
        // audio.play();
      }
      let is_new = true;
      let title = this.site_Title;
      var _this = this;

      this.titleLoop = setInterval(function () {
        if (is_new) {
          is_new = false;
          title = _this.site_Title;
        } else {
          is_new = true;
          title = _this.text_newmessage;
        }
        document.title = title;
      }, 2000);
    },
    checkHidenFunction(parse_datas) {
      // Check theo ngày trong tuần
      let hidden_day = false;
      let day_of_week = new Date().getDay();
      let page_day_working = parse_datas.booking_working_day;
      if (page_day_working && page_day_working.length > 0) {
        hidden_day = true;
        for (let i = 0; i < page_day_working.length; i++) {
          if (day_of_week == page_day_working[i]) {
            hidden_day = false;
            break;
          }
        }
      }
      if (!hidden_day) {
        if (parse_datas.startTime_webchat) {
          let startTime = parse_datas.startTime_webchat;
          var [hour, minute] = startTime.split(":").map(Number);
          var newDate_start = new Date();
          newDate_start.setHours(hour);
          newDate_start.setMinutes(minute);
          let endTime = parse_datas.endTime_webchat;
          var [hour, minute] = endTime.split(":").map(Number);
          var newDate_end = new Date();
          newDate_end.setHours(hour);
          newDate_end.setMinutes(minute);
          let timeNow = new Date();
          if (timeNow >= newDate_start && timeNow <= newDate_end) {
            this.checkHidden = false;
          }
        } else {
          this.checkHidden = false;
        }
      }
    },
  },
  async created() {
    if (this.screen == "full") {
      this.showchat = true;
    }
   
    if (localStorage.getItem("token_gpt_assistant")) {
      localStorage.removeItem("token_gpt_assistant");
    }
    let check_refresh_cache = 0
    if( localStorage.getItem("refresh_cache")) {
      check_refresh_cache = parseInt((localStorage.getItem("refresh_cache"), 10))
    } 
    if(!check_refresh_cache) {
      localStorage.clear();
      sessionStorage.clear();
    }

    if (sessionStorage.getItem("fchat_page_" + this.id)) {
      this.pageData = JSON.parse(
        sessionStorage.getItem("fchat_page_" + this.id)
      );

      var parse_datas = JSON.parse(
        sessionStorage.getItem("fchat_page_" + this.id)
      );
      if (parse_datas != null && parse_datas.page != "") {
        var parse_datas = parse_datas.page;
        this.checkHidenFunction(parse_datas);
      }
      this.initPage(this.pageData);
    } else {
      axios
        .get(config.API_URL + "webchat/getpage?page_id=" + this.id, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          var data_page = response.data;
          if (data_page.page == null) {
            console.log("page is null!");
            return;
          }
          if (data_page != null && data_page.page != "") {
            var parse_datas = data_page.page;
            this.checkHidenFunction(parse_datas);
          }
          if (data_page.shop.assistant_token_fchat_ai) {

            //console.log(data_page.shop.assistant_token_fchat_ai);
          }
          if (data_page.shop.token) {
            localStorage.setItem("token_shop", data_page.shop.token);
            //console.log(data_page.shop.assistant_id_fchat_ai);
          }

          // var check = localStorage.getItem('token_fchat_ai')
          // console.log(check);
          sessionStorage.setItem("fchat_page_" + this.id, JSON.stringify(data_page));
          localStorage.setItem("refresh_cache", 1);
          this.initPage(data_page);
        });
    }
    if (this.chatbutton) {
      this.checkHidden = true;
    }
  },
  mounted() {
    var _this = this;

    window.showFchatWebchat = async function (data) {
      this.id = data.page_id;
      if (localStorage.getItem("create_conv") == "true") {
        _this.openChat("open_chat");
        return;
      } else {
        if(!data.page_id || !data.sender_name) {
          this.form_email = data.email || "";
          this.form_phone = data.phone || "";
          _this.form_email = data.email || "";
          _this.form_phone = data.phone || "";
           if (!_this.is_loaded) {
            // Đợi đến khi component load xong
            const waitLoaded = setInterval(function () {
              if (_this.is_loaded) {
                clearInterval(waitLoaded);
                _this.openChat("open_chat");
              }
            }, 100);
            return;
          }
          //  _this.openChat("open_chat");
          //  return
        }else{
          let data_json = {
            page_id: data.page_id,
            sender_name: data.sender_name || "Guest",
            sender_id: data.user_id || "",
            email: data.email || "",
            phone: data.phone || "",
            crmid: _this.crm_url || "",
            lastmess: "Đã tạo hội thoại",
            ref: data.ref || "",
            src: data.src || "",
            title: "Bạn có tin nhắn mới!",
            url: _this.RemoveParamUrl(window.location.href),
          }
          if(data.avatar) {
            data_json.avatar = data.avatar 
          }
          await axios.post(
            config.API_URL_CLIENT + "webchat/createConv",
            data_json,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            localStorage.setItem("fchat_login", true);
            localStorage.setItem("fchat_userid", response.data.sender_id);
            localStorage.setItem("convsation_id", response.data.conv_id);
            localStorage.setItem("fchat_page_id", data.page_id);
            sessionStorage.setItem(
              "fchat_last_url",
              _this.RemoveParamUrl(window.location.href)
            );
            _this.is_login = true;
            this.is_login = true
            _this.fchat_userid = response.data.sender_id;
            this.fchat_userid = response.data.sender_id;
            _this.convsation_id = response.data.conv_id;
            this.convsation_id = response.data.conv_id;
            _this.socket.emit("room", data.page_id);
            _this.loadMessages(response.data.conv_id, 0);
            if (response.data.datas.sale_name) {
              _this.salelists = [];
              _this.salelists.push({
                avatar: response.data.datas.sale_avatar,
                full_name: response.data.datas.sale_name,
              });
              localStorage.setItem("fchat_sale", response.data.datas.sale_name);
              localStorage.setItem(
                "fchat_sale_avatar",
                response.data.datas.sale_avatar
              );
            }
            _this.sendChat()
            _this.sendGreating();

            if (_this.data_quick_delay && _this.data_quick_delay.length > 0) {
              setTimeout(function () {
                _this.sendBlock(_this.data_quick_delay);
              }, 1000);
            }
            _this.pingToServer();
            setInterval(function () {
              _this.pingToServer();
              sessionStorage.setItem("fchat_last_url", "");
            }, 60000 * 5);
          })
          .catch((e) => {
            console.log(e);
          });
        localStorage.setItem("create_conv", "true");
        var allIdConvertions =
          JSON.parse(localStorage.getItem("convsation_idList")) || [];
        // Thêm giá trị mới vào mảng
        allIdConvertions.push(this.convsation_id);
        // Lưu mảng mới vào localStorage
        localStorage.setItem(
          "convsation_idList",
          JSON.stringify(allIdConvertions)
        );
        var conversationInfo = {
          convsation_id: localStorage.getItem("convsation_id"),
          assistant_id: localStorage.getItem("assistant_id"),
        };
        // Chuyển đối tượng thành chuỗi JSON và lưu vào localStorage
        localStorage.setItem(
          "conversationInfo",
          JSON.stringify(conversationInfo)
        );
        var allConversationInfos =
          JSON.parse(localStorage.getItem("conversationInfoList")) || [];

        // Thêm đối tượng mới vào mảng
        allConversationInfos.push(conversationInfo);

        // Hiển thị tất cả các giá trị trong mảng
        localStorage.setItem(
          "conversationInfoList",
          JSON.stringify(allConversationInfos)
        );
        _this.webAction(4);
        var container_typing = _this.$el.querySelector("#typing_chat4");
        if (container_typing) {
          container_typing.style.display = "none"
        }
      }
      //  _this.openChat("open_chat")
      _this.showchat = true;
      sessionStorage.setItem("fchat_showchat", true);
      setTimeout(_this.scrollToEnd, 100);
    }
        }
      
    if (localStorage.getItem("token_gpt_assistant")) {
      localStorage.removeItem("token_gpt_assistant");
    }
    document.addEventListener("click", function () {
      _this.has_clicked = true;
    });
    document.addEventListener("scroll", function () {
      _this.has_clicked = true;
    });

    this.socket.on("connect", () => {
      var nameItem = "fchat_page_" + this.id;
      var datas_select = sessionStorage.getItem(nameItem);
      var response = JSON.parse(datas_select);
      if (response != null && response.page != "") {
        let parse_datas = response.page;
        this.checkHidenFunction(parse_datas);
      }
      this.socket.emit("room", this.id);
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        if (this.convsation_id) {
          this.messages = [];
          this.loadMessages(this.convsation_id, 0);
          this.view_conv = true;
          this.page = 0;
        }
      }
    });
    this.socket.on("disconnect", () => {
      sessionStorage.removeItem("fchat_conv_" + this.id);
      sessionStorage.removeItem("fchat_last_url");
    });

    window.addEventListener(
      "offline",
      () => {
        sessionStorage.removeItem("fchat_conv_" + this.id);
      },
      false
    );
    // Người đang typing
    this.socket.on("user-typing-conversation", (data) => {
      if (data.conv_id == this.convsation_id) {
        var container_typing = this.$el.querySelector("#typing_chat2");
        container_typing.style.display = "block";
        var container_typing1 = this.$el.querySelector("#typing_chat1");
        container_typing1.style.display = "block";
        container_typing1.style.display = "none";
        //  containerTyping1.style.display = 'block';
        setTimeout(function () {
          container_typing.style.display = "none";
          //  containerTyping1.style.display = 'none';
        }, 5000);
      }
    });
    // sale preview
    this.socket.on("sale-conversation", (data) => {
      if (this.convsation_id && data.conv_id == this.convsation_id) {
        this.salelists = [];
        if (data.sale_avatar) {
          this.salelists.push({
            avatar: data.sale_avatar,
            full_name: data.sale_name,
          });
          localStorage.setItem("fchat_sale", data.sale_name);
          localStorage.setItem("fchat_sale_avatar", data.sale_avatar);
        } else {
          this.salelists = [];
          localStorage.removeItem("fchat_sale");
          localStorage.removeItem("fchat_sale_avatar");
        }
      }
      if (!this.convsation_id) {
        sessionStorage.removeItem("fchat_conv_" + this.id);
        for (var key in this.conversations) {
          if (this.conversations[key]._id == data.conv_id) {
            if (data.sale_avatar) {
              this.conversations[key].sale_name = data.sale_name;
              this.conversations[key].sale_avatar = data.sale_avatar;
            } else {
              this.conversations[key].sale_name = this.web_name;
              this.conversations[key].sale_avatar = this.web_logo;
            }
          }
        }
      }
    });
    // Sale setDone
    this.socket.on("setdone-conversation", (data) => {
      if (this.convsation_id && data.conv_id == this.convsation_id) {
        this.show_rating = true;
        localStorage.setItem("fchat_show_rating", true);
      }
      if (!this.convsation_id) {
        sessionStorage.removeItem("fchat_conv_" + this.id);
        for (var key in this.conversations) {
          if (this.conversations[key]._id == data.conv_id) {
            this.conversations[key].is_done = true;
          }
        }
      }
    });
    // Người đang typing block
    this.socket.on("webchat-typing", (data) => {
      if (data.conv_id == this.convsation_id) {
        //var containerTyping1 = this.$el.querySelectorAll(".chat_avatar");

        var container_typing = this.$el.querySelector("#typing_chat2");
        setTimeout(function () {
          container_typing.style.display = "block";
          // containerTyping1.style.display = 'block';
          setTimeout(function () {
            container_typing.style.display = "none";
            // containerTyping1.style.display = 'none';
          }, data.time_delay * 1000);
        }, 1000);
      }
    });
    this.socket.on("quick-message", (data) => {
      if (data.conv_id == this.convsation_id) {
        this.data_quickshow = data.quick;
        this.data_quicknext = data;
        localStorage.setItem("data_quickshow", JSON.stringify(data.quick));
        localStorage.setItem("data_quicknext", JSON.stringify(data));
      }
    }),
      this.socket.on("quick-assistant", (data) => {
        // console.log("quick 2915:",data);

        if (data.conv_id == this.convsation_id) {
          this.data_assistantshow = data.quick;

          this.data_quicknext = data;
          // localStorage.setItem('thread_id', JSON.stringify(data.quick[0].thread_id));
          localStorage.setItem(
            "data_assistantshow",
            JSON.stringify(data.quick)
          );
          localStorage.setItem("data_quicknext", JSON.stringify(data));
        }

      }),
      this.socket.on("webform-message", (data) => {
        if (data.conv_id == this.convsation_id) {
          let data_push = { data };
          data_push.id = this.messages[this.messages.length - 1]._id;

          if (!this.data_webform) {
            this.data_webform = [];
          }
          this.data_webform.push(data_push);
          localStorage.setItem(
            "webform_" + this.id,
            JSON.stringify(this.data_webform)
          );
        }
      }),
      this.socket.on("userinput-message", (data) => {
        // console.log(data);
        if (data.conv_id == this.convsation_id) {
          this.data_userinputnext = data;
          localStorage.setItem("data_userinputnext", JSON.stringify(data));
        }
      }),
      this.socket.on("new-message", (data) => {
        if (data.message.message.toLowerCase() == "stop") {
          //console.log('stop chatgpt:',data.message.message);
          // this.tunoffAssistant();
          var containerTyping = this.$el.querySelector("#typing_chat1");
          containerTyping.style.display = "none";
          setTimeout(this.scrollToEnd, 500);
        }
        if (
          data.message.is_Page_Reply == true &&
          data.conversation._id == this.convsation_id
        ) {
          this.updateRead(data.conversation._id);

          if (!this.showchat) {
            if (data.message.message != "") {
              var message_text = data.message.message;
            } else {
              var message_text = "Tệp đính kèm";
            }

            let data_preview = {
              message: message_text,
            };

            this.preview_conv.unshift(data_preview);
            if (this.preview_conv.length > 3) {
              this.preview_conv.pop();
            }
            this.siteTitle();
            this.unread_count++;
            localStorage.setItem("fchat_unread_count", this.unread_count);
          }
          localStorage.removeItem("data_quicknext");
          localStorage.removeItem("data_quickshow");
          localStorage.removeItem("data_assistantshow");

          this.data_quicknext = [];
          this.data_quickshow = [];
          this.data_assistantshow = [];
          this.messages.push(data.message);
          if (localStorage.getItem(this.convsation_id)) {
            var messages = JSON.parse(localStorage.getItem(this.convsation_id));
            messages.push(data.message);
            localStorage.setItem(this.convsation_id, JSON.stringify(messages));
            localStorage.setItem(
              "assistant_status_1",
              data.conversation.assistant_status
            );
          } else {
            let message_datas = data.message;
            if (!Array.isArray(message_datas)) {
              message_datas = [message_datas];
            }
            localStorage.setItem(
              this.convsation_id,
              JSON.stringify(message_datas)
            );
          }
          setTimeout(this.scrollToEnd, 1000);
        }
        if (!this.convsation_id) {
          sessionStorage.removeItem("fchat_conv_" + this.id);
          this.clearIntTitle();
          for (var key in this.conversations) {
            if (this.conversations[key]._id == data.conversation._id) {
              this.conversations[key].isReadWeb = false;
              this.conversations[key].updated_at = new Date();
              this.conversations[key].last_mess = {
                message: data.message.message,
                is_page_reply: data.message.is_Page_Reply,
              };
            }
            if (this.conversations[key].isReadWeb == false) {
              this.unread_count++;
              this.siteTitle();
            }
          }
        }
      });
    this.socket.on("receive-message", (data) => {
      //console.log(data);
      if (data.message.whisper) {
        return;
      }
      if (
        data.user_send != this.fchat_userid &&
        data.conversation_id == this.convsation_id
      ) {
        this.updateRead(data.conversation_id);

        // var count_messages = parseInt(this.messages.length) - 1;
        // if (this.messages[count_messages].is_Page_Reply && this.messages[count_messages].chat_by.facebook_id) {
        //   if (data.message.chat_by.facebook_id && data.message.chat_by.facebook_id != '' && this.messages[count_messages].chat_by.facebook_id == data.message.chat_by.facebook_id) {
        //     this.messages[count_messages].none_avatar = true;
        //   }else{
        //     this.messages[count_messages].none_avatar = false;
        //   }
        // }
        if (!this.showchat) {
          if (data.message.message != "") {
            var message_text = data.message.message;
          } else {
            var message_text = "Tệp đính kèm";
          }
          let data_preview = {
            message: message_text,
          };
          this.preview_conv.unshift(data_preview);
          if (this.preview_conv.length > 3) {
            this.preview_conv.pop();
          }
          this.unread_count++;
          this.siteTitle();
          localStorage.setItem("fchat_unread_count", this.unread_count);
        }
        this.messages.push(data.message);
        // this.MessStorage(data.message);
        if (localStorage.getItem(this.convsation_id)) {
          var messages = JSON.parse(localStorage.getItem(this.convsation_id));
          messages.push(data.message);
          localStorage.setItem(this.convsation_id, JSON.stringify(messages));
        } else {
          localStorage.setItem(
            this.convsation_id,
            JSON.stringify(data.message)
          );
        }
        localStorage.removeItem("data_quicknext");
        localStorage.removeItem("data_quickshow");
        localStorage.removeItem("data_assistantshow");
        this.data_quicknext = [];
        this.data_quickshow = [];
        this.data_assistantshow = [];
        setTimeout(this.scrollToEnd, 100);
      }
      if (!this.convsation_id) {
        sessionStorage.removeItem("fchat_conv_" + this.id);
        this.clearIntTitle();
        for (var key in this.conversations) {
          if (this.conversations[key]._id == data.conversation_id) {
            this.conversations[key].isReadWeb = false;
            this.conversations[key].updated_at = new Date();
            this.conversations[key].last_mess = {
              message: data.message.message,
              is_page_reply: data.message.is_Page_Reply,
            };
          }
          if (this.conversations[key].isReadWeb == false) {
            this.unread_count++;
            this.siteTitle();
          }
        }
      }
    });
  },
};
</script>
<style src="@/assets/init.css"></style>